import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { TiMessages } from "react-icons/ti";
import { IoIosCloseCircleOutline } from "react-icons/io";
import "../../styles/scrollbar.css";
import chaticon from "../Assets/chaaat.png";

const styles = {
  chatbotContainer: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "370px",
    zIndex: 9001,
  },
  chatbotButton: {
    background: "linear-gradient(#1B0E3C, #1B0E3C) padding-box, linear-gradient(to right, #C9A84B, #8A5DF4) border-box",
    color: "#1a1a1a",
    padding: "15px",
    borderRadius: "16px",
    cursor: "pointer",
    border: "2px solid transparent",   // transparent â€” gradient shows through
    position: "absolute",
    bottom: "0",
    right: "0",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
  },
  chatbot: {
    fontFamily: "Arial, sans-serif",
    width: "100%",
    height: "550px",
    backgroundColor: "#111111", // Dark background to match site
    borderRadius: "15px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
    border: "1px solid #DFBD69", // Gold border
    display: "none",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "hidden",
    marginBottom: "20%",
  },
  messageContainer: {
    overflowY: "auto",
    flex: 1,
    padding: "10px",
    maxHeight: "400px",
    backgroundColor: "#1a1a1a", // Slight contrast from main background
  },
  messageBox: {
    marginBottom: "10px",
    fontSize: "0.95rem",
    padding: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
    maxWidth: "80%",
    whiteSpace: "pre-wrap",
    // You'll likely need to set specific colors dynamically in the component for user vs bot:
    // User: backgroundColor: "#DFBD69", color: "#1a1a1a"
    // Bot: backgroundColor: "#2a2a2a", color: "#f5f5f5"
    color: "#f5f5f5",
  },
  inputContainer: {
    display: "flex",
    padding: "10px",
    backgroundColor: "#111111",
    borderTop: "1px solid #DFBD69",
  },
  input: {
    flex: 1,
    border: "1px solid #333",
    backgroundColor: "#222",
    color: "#DFBD69",
    padding: "10px",
    borderRadius: "5px",
    fontSize: "0.95rem",
    outline: "none",
  },
  button: {
    marginLeft: "10px",
    backgroundColor: "#DFBD69", // Changed from blue to gold
    color: "#111",
    padding: "10px 15px",
    borderRadius: "5px",
    cursor: "pointer",
    border: "none",
    fontWeight: "bold",
  },
  questionButton: {
    backgroundColor: "transparent", 
    color: "#DFBD69", // Gold text
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
    border: "1px solid #DFBD69", // Gold outline
    margin: "3px",
    fontSize: "0.85rem",
    display: "inline-block",
  },
  suggestionSection: {
    padding: "8px 10px",
    backgroundColor: "#111111",
    borderTop: "1px solid rgba(223, 189, 105, 0.2)",
  },
  suggestionLabel: {
    color: "#cbb06a",
    fontSize: "0.78rem",
    textAlign: "left",
    marginBottom: "8px",
    letterSpacing: "0.02em",
  },
  suggestionList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    justifyContent: "flex-start",
  },
  suggestionChip: {
    backgroundColor: "#1f1f1f",
    color: "#DFBD69",
    border: "1px solid rgba(223, 189, 105, 0.4)",
    borderRadius: "999px",
    padding: "7px 12px",
    cursor: "pointer",
    fontSize: "0.82rem",
    lineHeight: 1.2,
  },
  // Chart styling adapted for dark theme
  chartContainer: {
    width: "80%",
    margin: "10px 0",
    padding: "15px",
    backgroundColor: "#222", // Dark base
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
    border: "1px solid #333",
    alignSelf: "flex-start",
  },
  chart: {
    width: "100%",
    margin: "15px auto",
    backgroundColor: "#2a2a2a", // Darker chart surface
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
    maxWidth: "100%",
  },
  individualChart: {
    width: "80%",
    margin: "10px 0",
    backgroundColor: "#2a2a2a", // Dark background
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    maxWidth: "90%",
  },
  barContainer: {
    height: "26px",
    backgroundColor: "#1a1a1a", // Dark track
    borderRadius: "5px",
    marginBottom: "3px",
    position: "relative",
    overflow: "hidden",
    border: "1px solid #333",
  },
  bar: {
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    borderRadius: "5px",
    transition: "width 1s ease-in-out",
  },
  barValue: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    fontWeight: "bold",
    fontSize: "0.85rem",
    color: "#fff", // White text over the bar
    zIndex: 2,
    textShadow: "1px 1px 2px rgba(0,0,0,0.8)", // Ensure readability
  },
  scoreTitle: {
    textAlign: "center",
    fontWeight: "bold",
    color: "#DFBD69", // Gold titles
    margin: "0 0 10px 0",
    fontSize: "0.95rem",
  },
  strengthIndicator: {
    textAlign: "center",
    fontStyle: "italic",
    color: "#aaa", // Light gray
    marginTop: "5px",
    fontSize: "0.85rem",
  },
  helpButton: {
    backgroundColor: "transparent",
    color: "#DFBD69",
    padding: "8px 15px",
    borderRadius: "5px",
    cursor: "pointer",
    border: "1px solid #DFBD69",
    margin: "10px auto",
    fontSize: "0.9rem",
    display: "block",
    width: "fit-content",
  },
  restartButtonContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "0 10px 10px 10px",
    marginTop: "5px",
    backgroundColor: "#111111",
  },
  restartButtonBottom: {
    backgroundColor: 'transparent',
    color: '#DFBD69', // Changed from red to gold
    padding: '8px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    border: '1px solid #DFBD69',
    width: '100%',
    fontSize: '0.9rem'
  },
};

// Simple Bar Chart Component
const SimpleChart = ({ data, title }) => {
  const getBarColor = (category) => {
    const colors = {
      WEALTH: "#8884d8",
      HEALTH: "#82ca9d",
      CAREER: "#ffc658",
      RS: "#ff8042",
      WISDOM: "#0088fe",
    };
    return colors[category] || "#777";
  };

  // Function to determine strength based on value
  const getStrengthLabel = (value) => {
    if (value < 30) return "weak";
    if (value < 60) return "moderate";
    if (value < 85) return "strong";
    return "excellent";
  };

  return (
    <div style={styles.individualChart}>
      <h4 style={styles.scoreTitle}>{title}</h4>
      <div style={styles.barContainer}>
        <div
          style={{
            ...styles.bar,
            width: `${data.value}%`,
            backgroundColor: getBarColor(data.category),
          }}
        ></div>
        <span style={styles.barValue}>{data.value}/100</span>
      </div>
      <div style={styles.strengthIndicator}>{getStrengthLabel(data.value)}</div>
    </div>
  );
};

// Chart component specifically for use in the all charts display
const NatalChart = ({ data, title }) => {
  const getBarColor = (category) => {
    const colors = {
      WEALTH: "#8884d8",
      HEALTH: "#82ca9d",
      CAREER: "#ffc658",
      RS: "#ff8042",
      WISDOM: "#0088fe",
    };
    return colors[category] || "#777";
  };

  // Function to determine strength based on value
  const getStrengthLabel = (value) => {
    if (value < 30) return "weak";
    if (value < 60) return "moderate";
    if (value < 85) return "strong";
    return "excellent";
  };

  return (
    <div style={styles.chart}>
      <h4 style={styles.scoreTitle}>{title}</h4>
      <div style={styles.barContainer}>
        <div
          style={{
            ...styles.bar,
            width: `${data.value}%`,
            backgroundColor: getBarColor(data.category),
          }}
        ></div>
        <span style={styles.barValue}>{data.value}/100</span>
      </div>
      <div style={styles.strengthIndicator}>{getStrengthLabel(data.value)}</div>
    </div>
  );
};

const Chatbot = () => {
  const navigate = useNavigate();
  // Add this state at the beginning of your component
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [questions, setQuestions] = useState([]);
  const [suggestedKeywords, setSuggestedKeywords] = useState([]);
  const [suggestionPage, setSuggestionPage] = useState(0);
  const SUGGESTIONS_PER_PAGE = 8;
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [hideInitialQuestions, setHideInitialQuestions] = useState(true); // Hide buttons on first API call
  const [isFirstSelection, setIsFirstSelection] = useState(true);
  // Add new states for analytics
  const [showChart, setShowChart] = useState(false);
  const [chartData, setChartData] = useState(null);
  const [chartTitle, setChartTitle] = useState("");
  // Add these state declarations here instead of inside fetchResponse
  const [showHelpButton, setShowHelpButton] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [hideCategoryButtons, setHideCategoryButtons] = useState(false);
  const [apiDate, setApiDate] = useState();
  const [allCharts, setAllCharts] = useState([]);
  const [showRestartButton, setShowRestartButton] = useState(false);
  const hasMounted = useRef(false);

  const [userDataSet, setUserData] = useState(null);

  const [Lwealth, setLWealth] = useState(10);
  const [Lcareer, setLCareer] = useState(10);
  const [Lrs, setLRs] = useState(10);
  const [Lhealth, setLHealth] = useState(10);
  const [Lwisdom, setLWisdom] = useState(10);
  // for test
  // const [userGender, setUserGender] = useState("Female");
  const [userGender, setUserGender] = useState("");
  const [keywordMappings, setKeywordMappings] = useState({});

  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    let interval;
    if (loading) {
      interval = setInterval(() => {
        setDotCount((prev) => (prev < 3 ? prev + 1 : 1));
      }, 400);
    } else {
      setDotCount(1);
    }
    return () => clearInterval(interval);
  }, [loading]);

  
  // 1. Create a ref to attach to the bottom of the message container
  const messagesEndRef = useRef(null);

  // 2. Create an auto-scroll function
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // 3. Trigger the scroll whenever the messages array (or loading state) changes
  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]); 

  const [userZodiac, setUserZodiac] = useState({
    sign: "",
    chineseSign: "",
    natal: ""
  });

  const [chartStrengthData, setChartStrengthData] = useState({
    rawValue: "",
    category: "" // "strong" or "weak"
  });

  const [lunarData, setLunarData] = useState({
    A1: null,
    A2: null,
    A3: null,
    A4: null,
    B1: null,
    B2: null,
    B3: null,
    B4: null
  });

  const [userChartValues, setUserChartValues] = useState({
    WEALTH: 0,
    CAREER: 0,
    RS: 0,
    HEALTH: 0,
    WISDOM: 0
  });

  const fetchUserData = async () => {
    try {
      const userName = localStorage.getItem("username");
      const userID = localStorage.getItem("userID");

      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            UserName: userName,
            ID: userID,
            UserToken: "",
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          }),
        }
      );

      const result = await response.json();
      // // console.log("API Response:", result);

      if (response.ok) {
        const userDOB = result.Profiles[0].DOB;
        if (userDOB && !isNaN(new Date(userDOB).getTime())) {
          setApiDate(userDOB);
          // // console.log("Valid DOB set as apiDate:", userDOB);
          
          // Fetch chart values after setting the date - this is the key addition
          // await displayAllCharts(userDOB);
        } else {
          // // console.error("Invalid DOB received:", userDOB);
        }
        setUserGender(result.Profiles[0].Gender);
        
        return {
          ...result.Profiles[0],
          DOB: userDOB
        };
      } else {
        throw new Error(
          `Error: ${response.status} - ${result.message || "Request failed"}`
        );
      }
    } catch (error) {
      // // console.error("Error fetching data:", error);
      return null;
    }
  };

  const LunarConvert = async () => {
    // // console.log("Ensuring critical data is loaded...");
    
    try {
      // // When you get DOB and time from CRM, combine them: (uncomment when testing)
      // const crmDate = "2001-01-08"; // from CRM
      // const crmTime = "00:00";      // from CRM

      // // Combine to ISO string in local time
      // const apiDate = `${crmDate}T${crmTime}:00.000+08:00`; // for Philippine Standard Time
      // Parse the date from apiDate state
      const birthDate = new Date(apiDate);
      const year = birthDate.getFullYear();
      const month = (birthDate.getMonth() + 1).toString().padStart(2, "0");
      const day = birthDate.getDate().toString().padStart(2, "0");
      const hour = birthDate.getHours();
      const minutes = birthDate.getMinutes();

      // Format time as HH:MM
      const timeString = `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

      // console.log(`Fetching critical data with: ${birthDate}`);
      // console.log(`Parsed date: Year=${year}, Month=${month}, Day=${day}, Time=${timeString}`);

      // Combined API call to get both lunar data and chart strength
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
      );
      
      const data = await response.json();
      // console.log("Raw API response:", data);

      if (Array.isArray(data) && data.length > 0) {
        // Extract and set chart strength
        const chartStrength = data[0].CHART_STRENGHT;
        // console.log("Chart Strength:", chartStrength);

        // Determine if strong or weak based on the string value
        const strengthCategory = chartStrength?.toLowerCase() === "strong" ? "strong" : "weak";
        
        // Update chart strength state
        setChartStrengthData({
          rawValue: chartStrength,
          category: strengthCategory
        });
        
        // Store lunar values
        const lunarValues = {
          A1: data[0]?.A1 || null,
          A2: data[0]?.A2 || null,
          A3: data[0]?.A3 || null,
          A4: data[0]?.A4 || null,
          B1: data[0]?.B1 || null,
          B2: data[0]?.B2 || null,
          B3: data[0]?.B3 || null,
          B4: data[0]?.B4 || null
        };

        // If A2 is missing, fetch it from the GetLunarHeavenlyStems API
        if (!lunarValues.A2) {
          const lunarResponse = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
          );
          
          const zodiacData = await lunarResponse.json();
          
          if (zodiacData && zodiacData.length > 0) {
            if (zodiacData[0].NATAL) {
              lunarValues.A2 = zodiacData[0].NATAL;
              // console.log("Retrieved A2 value from GetLunarHeavenlyStems API:", lunarValues.A2);
            } else if (zodiacData[0].B1) {
              lunarValues.A2 = zodiacData[0].B1;
              // console.log("Retrieved A2 value from B1 in GetLunarHeavenlyStems API:", lunarValues.A2);
            }
            
            // Also store zodiac sign information
            if (zodiacData[0].ZODIAC) {
              setUserZodiac(prev => ({
                ...prev,
                sign: zodiacData[0].ZODIAC,
                chineseSign: zodiacData[0].ZODIAC_CN || ""
              }));
            }
          }
        }
        
        // Update lunar data state
        setLunarData(lunarValues);
        // console.log("Lunar data successfully loaded:", lunarValues);
        
        // Also update userZodiac.natal
        if (lunarValues.A2) {
          setUserZodiac(prev => ({
            ...prev,
            natal: lunarValues.A2
          }));
          localStorage.setItem("userNatalElement", lunarValues.A2);
        }
        
        // console.log("Critical data successfully loaded");
        return true;
      }
      return false;
    } catch (error) {
      // console.error("Error fetching critical data:", error);
      return false;
    }
  };

  // Add this function to ensure chart strength is fetched
  const ensureCriticalData = async () => {
    // console.log("Ensuring critical data is loaded...");
    
    try {
      //  // When you get DOB and time from CRM, combine them: (uncomment when testing)
      // const crmDate = "2001-01-08"; // from CRM
      // const crmTime = "00:00";      // from CRM

      // // Combine to ISO string in local time
      // const apiDate = `${crmDate}T${crmTime}:00.000+08:00`; // for Philippine Standard Time
      // Parse the date from apiDate state
      const birthDate = new Date(apiDate);
      const year = birthDate.getFullYear();
      const month = (birthDate.getMonth() + 1).toString().padStart(2, "0");
      const day = birthDate.getDate().toString().padStart(2, "0");
      const hour = birthDate.getHours();
      const minutes = birthDate.getMinutes();

      // Format time as HH:MM
      const timeString = `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

      // console.log(`Fetching critical data with: ${birthDate}`);
      // console.log(`Parsed date: Year=${year}, Month=${month}, Day=${day}, Time=${timeString}`);

      // Combined API call to get both lunar data and chart strength
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
      );
      
      const data = await response.json();
      // console.log("Raw API response:", data);

      if (Array.isArray(data) && data.length > 0) {
        // Extract and set chart strength explicitly
        const chartStrength = data[0].CHART_STRENGHT;
        // console.log("Chart Strength from API:", chartStrength);

        // Determine if strong or weak based on the string value
        const strengthCategory = chartStrength?.toLowerCase() === "strong" ? "strong" : "weak";
        
        // Update chart strength state
        setChartStrengthData({
          rawValue: chartStrength,
          category: strengthCategory
        });
        
        // Store the chart strength in localStorage for persistence
        localStorage.setItem("userChartStrength", JSON.stringify({
          rawValue: chartStrength,
          category: strengthCategory
        }));
        
        // Also update lunar data from this API call
        const lunarValues = {
          A1: data[0]?.A1 || null,
          A2: data[0]?.A2 || null,
          A3: data[0]?.A3 || null,
          A4: data[0]?.A4 || null,
          B1: data[0]?.B1 || null,
          B2: data[0]?.B2 || null,
          B3: data[0]?.B3 || null,
          B4: data[0]?.B4 || null
        };
        
        // Update lunar data state
        setLunarData(lunarValues);
        // console.log("Lunar data successfully loaded:", lunarValues);

        localStorage.setItem("lunarData", JSON.stringify(lunarValues));
        
        // If A2 is missing, try the other API call
        if (!lunarValues.A2) {
          await LunarConvert();
        }
        
        return true;
      } else {
        // console.error("Failed to fetch chart strength, API didn't return expected data");
        
        // Try loading from localStorage as fallback
        const savedChartStrength = localStorage.getItem("userChartStrength");
        if (savedChartStrength) {
          const parsedStrength = JSON.parse(savedChartStrength);
          // console.log("Using saved chart strength from localStorage:", parsedStrength);
          setChartStrengthData(parsedStrength);
          return true;
        }
        
        // If all else fails, set a default value
        // console.log("Setting default chart strength to 'strong'");
        setChartStrengthData({
          rawValue: "Strong",
          category: "strong"
        });
        return false;
      }
    } catch (error) {
      // console.error("Error ensuring critical data:", error);
      
      // Set default values as a last resort
      setChartStrengthData({
        rawValue: "Strong",
        category: "strong"
      });
      return false;
    }
  };

  // const fetchChartStrength = async () => {
  //   try {
  //     // Parse the date from apiDate state
  //     const birthDate = new Date(apiDate);
  //     const year = birthDate.getFullYear();
  //     const month = (birthDate.getMonth() + 1);
  //     const day = birthDate.getDate();
  //     const hour = birthDate.getHours();
  //     const minutes = birthDate.getMinutes();

  //     // Format time as HH:MM
  //     const timeString = `${hour.toString().padStart(2, "0")}:${minutes
  //       .toString()
  //       .padStart(2, "0")}`;

  //     // Keep the original API endpoint with corrected cYear parameter
  //     const response = await fetch(
  //       `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
  //     );

  //     const data = await response.json();
  //     // console.log("Chinese DOB API Response:", data);
      
  //     // Check if data is an array (single array format)
  //     if (Array.isArray(data) && data.length > 0) {
  //       // Get the chart strength from the first object in the array
  //       const chartStrength = data[0].CHART_STRENGHT;
  //       // console.log("Chart Strength:", chartStrength);

  //       // Determine if strong or weak based on the string value
  //       const strengthCategory = chartStrength.toLowerCase() === "strong" ? "strong" : "weak";
        
  //       // Save the information to state without numerical conversion
  //       setChartStrengthData({
  //         rawValue: chartStrength,
  //         category: strengthCategory
  //       });
        
  //       return {
  //         chartStrength,
  //         strengthCategory
  //       };
  //     } else {
  //       throw new Error("Chart strength data not found in API response");
  //     }
  //   } catch (error) {
  //     // console.error("Error fetching chart strength:", error);
  //     return null;
  //   }
  // };

  const checkUserLogin = () => {
    const userName = localStorage.getItem("username");
    const userID = localStorage.getItem("userID");

    // If both username and userID exist, consider the user logged in
    if (userName && userID) {
      setIsLoggedIn(true); // Uncomment this line if you want to set logged in state
      //setIsLoggedIn(false);
    } else {
      setIsLoggedIn(false);
    }
  };
  
  // const fetchKeywordMappings = async () => {
  //   try {
  //     const response = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
  //     const data = await response.json();
      
  //     // Convert the array into a more usable object structure
  //     const mappings = {};
  //     data.forEach(item => {
  //       if (!item.KeywordText) return;
  //       // Split multiple keywords and trim them
  //       const keywords = item.KeywordText.split(',').map(k => k.trim().toLowerCase());
        
  //       // Map each keyword to its question ID
  //       keywords.forEach(keyword => {
  //         mappings[keyword] = item.QuestionID;
  //       });
  //     });
      
  //     // console.log("Keyword mappings loaded:", mappings);
  //     setKeywordMappings(mappings);
  //   } catch (error) {
  //     // console.error("Error fetching keyword mappings:", error);
  //   }
  // };

  // const getCharacterTargetId = (gender, natalElement, chartStrength) => {
  //     const isStrongChart = chartStrength?.category === "strong";
  //     const userGenderData = gender.toLowerCase();
      
  //     // console.log(`Character detection - Gender: ${userGenderData}, Natal: ${natalElement}, Strength: ${isStrongChart ? "Strong" : "Weak"}`);
      
  //     // First determine based on gender and natal element
  //     if (natalElement) {
  //       if (userGenderData === "female") {
  //         // FEMALE with natal element logic
  //         if (natalElement.includes("ä¸™")) return isStrongChart ? "1925" : "1926";
  //         if (natalElement.includes("ä¸")) return isStrongChart ? "1929" : "1938";
  //         if (natalElement.includes("æˆŠ")) return isStrongChart ? "1941" : "1942";
  //         if (natalElement.includes("å·±")) return isStrongChart ? "1945" : "1946";
  //         if (natalElement.includes("åºš")) return isStrongChart ? "1949" : "1951";
  //         if (natalElement.includes("è¾›")) return isStrongChart ? "1954" : "1955";
  //         if (natalElement.includes("å£¬")) return isStrongChart ? "1958" : "1959";
  //         if (natalElement.includes("ç™¸")) return isStrongChart ? "1962" : "1963";
  //         if (natalElement.includes("ç”²")) return isStrongChart ? "1917" : "1918"; // ç”² female
  //         if (natalElement.includes("ä¹™")) return isStrongChart ? "1921" : "1922";
          
  //         return isStrongChart ? "701" : "702"; // Default female
  //       } else {
  //         // MALE with natal element logic
  //         if (natalElement.includes("ä¸™")) return isStrongChart ? "1923" : "1924";
  //         if (natalElement.includes("ä¸")) return isStrongChart ? "1927" : "1928";
  //         if (natalElement.includes("æˆŠ")) return isStrongChart ? "1939" : "1940";
  //         if (natalElement.includes("å·±")) return isStrongChart ? "1943" : "1944";
  //         if (natalElement.includes("åºš")) return isStrongChart ? "1947" : "1948";
  //         if (natalElement.includes("è¾›")) return isStrongChart ? "1952" : "1953";
  //         if (natalElement.includes("å£¬")) return isStrongChart ? "1956" : "1957";
  //         if (natalElement.includes("ç™¸")) return isStrongChart ? "1960" : "1961";
  //         if (natalElement.includes("ç”²")) return isStrongChart ? "1911" : "1912"; // ç”² male
  //         if (natalElement.includes("ä¹™")) return isStrongChart ? "1919" : "1920";
          
  //         return isStrongChart ? "692" : "693"; // Default male
  //       }
  //     } else if (chartStrength?.category) {
  //       // No natal element, fallback to gender+strength only
  //       return userGenderData === "female" ? 
  //         (isStrongChart ? "701" : "702") : 
  //         (isStrongChart ? "692" : "693");
  //     } else {
  //       // Default if neither natal nor chart strength
  //       return userGenderData === "female" ? "701" : "692"; // Default to strong
  //     }
  //   };

    const selfIdentityKeywords = [
      "myself", "about me", "define", "true self", "identity", 
      "describe", "personality", "reveal", "day master", "heavenly stem",
      "who am i", "who am i?", "what type of person am i", "me"
    ];

    const handleWhoAmI = async () => {
      try {
        setLoading(true);
        
        // Add user's query to messages first
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: "Who am I?" }
        ]);

        // console.log("Current natal element value:", userZodiac.natal);
        // console.log("Current lunarData.A2 value:", lunarData.A2);
        // console.log("CRITICAL DATA CHECK for Who am I:");
        // console.log("Gender:", userGender); 
        // console.log("Chart Strength:", chartStrengthData);
        // console.log("Natal Element:", userZodiac.natal);
        
        // Force defaults if any data is missing
        const effectiveGender = userGender || "Male";
        const effectiveStrength = chartStrengthData?.category || "strong";
        const isStrongChart = effectiveStrength === "strong";
        
        // Get the targetId directly without going through the identity detection
        let targetId;
        
        // MALE with natal element logic - hardcoded IDs for direct mapping
        if (effectiveGender.toLowerCase() === "male") {
          if (userZodiac.natal?.includes("ä¸™")) targetId = isStrongChart ? "1923" : "1924";
          else if (userZodiac.natal?.includes("ä¸")) targetId = isStrongChart ? "1927" : "1928";
          else if (userZodiac.natal?.includes("æˆŠ")) targetId = isStrongChart ? "1939" : "1940";
          else if (userZodiac.natal?.includes("å·±")) targetId = isStrongChart ? "1943" : "1944";
          else if (userZodiac.natal?.includes("åºš")) targetId = isStrongChart ? "1947" : "1948";
          else if (userZodiac.natal?.includes("è¾›")) targetId = isStrongChart ? "1952" : "1953";
          else if (userZodiac.natal?.includes("å£¬")) targetId = isStrongChart ? "1956" : "1957";
          else if (userZodiac.natal?.includes("ç™¸")) targetId = isStrongChart ? "1960" : "1961";
          else if (userZodiac.natal?.includes("ç”²")) targetId = isStrongChart ? "1911" : "1912";
          else if (userZodiac.natal?.includes("ä¹™")) targetId = isStrongChart ? "1919" : "1920";
          else targetId = isStrongChart ? "692" : "693"; // Default male
        } else {
          // FEMALE with natal element logic
          if (userZodiac.natal?.includes("ä¸™")) targetId = isStrongChart ? "1925" : "1926";
          else if (userZodiac.natal?.includes("ä¸")) targetId = isStrongChart ? "1929" : "1938";
          else if (userZodiac.natal?.includes("æˆŠ")) targetId = isStrongChart ? "1941" : "1942";
          else if (userZodiac.natal?.includes("å·±")) targetId = isStrongChart ? "1945" : "1946";
          else if (userZodiac.natal?.includes("åºš")) targetId = isStrongChart ? "1949" : "1951";
          else if (userZodiac.natal?.includes("è¾›")) targetId = isStrongChart ? "1954" : "1955";
          else if (userZodiac.natal?.includes("å£¬")) targetId = isStrongChart ? "1958" : "1959";
          else if (userZodiac.natal?.includes("ç™¸")) targetId = isStrongChart ? "1962" : "1963";
          else if (userZodiac.natal?.includes("ç”²")) targetId = isStrongChart ? "1917" : "1918";
          else if (userZodiac.natal?.includes("ä¹™")) targetId = isStrongChart ? "1921" : "1922";
          else targetId = isStrongChart ? "701" : "702"; // Default female
        }
        
        // console.log(`Direct Who am I handling - Using targetId: ${targetId}`);
        
        // Make the API call with the determined ID - IMPORTANT: Use "myself" as the keyword
        const queryParam = `userQuery=myself`;
        const idParam = `&questionid=${targetId}`;
        
        // console.log(`Making identity API call: ${queryParam}${idParam}`);
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        // console.log(`Identity API response with ID ${targetId}:`, data);
        
        // Add bot response
        setMessages((prev) => [
          ...prev,
          { sender: "bot", text: data.answer || "Here's insight about your character..." }
        ]);
        
        // Handle selections if any
        if (data.selection) {
          const cleanedSelection = data.selection.replace(/\n/g, '');
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          setQuestions(selections);
          setHideInitialQuestions(false);
        } else {
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);
      } catch (error) {
        // console.error("Error in handleWhoAmI function:", error);
        // Fall back to showing a generic message
        setMessages((prev) => [
          ...prev,
          { 
            sender: "bot", 
            text: "I had trouble analyzing your character. Please try again later." 
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    

    // const fetchData = async () => {
    //   try {

    //     const userName = localStorage.getItem("username");
    //     const userID = localStorage.getItem("userID");

    //     const response = await fetch(
    //       "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
    //       {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //           UserName: userName,
    //           ID: userID,
    //           UserToken: "",
    //           Token: {
    //             AccessToken:
    //               "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
    //           },
    //         }),
    //       }
    //     );

    //     const result = await response.json();

    //     // console.log("API Response:", result); // Log the entire response

    //     if (response.ok) {
    //       // Check if response is OK
    //       setEmail(result.Profiles[0].Email);
    //       setUsername(result.Profiles[0].FullName);
    //       setDob(result.Profiles[0].DOB);
    //       setGender(result.Profiles[0].Gender);
    //       LunarConvert(result.Profiles[0].DOB);
    //       // console.log(result);
    //     } else {
    //       throw new Error(
    //         `Error: ${response.status} - ${result.message || "Request failed"}`
    //       );
    //     }
    //   } catch (error) {
    //     // console.error("Error fetching data:", error);
    //   }
    // };

    
  

    // // console.log("CRITICAL DATA CHECK:");
    // // console.log("Gender:", userGender);
    // // console.log("Chart Strength:", chartStrengthData);
    //console.log("Natal Element:", data[0].A2);


  // const fetchUserData = async () => {
  //   try {
  //     const userName = localStorage.getItem("username");
  //     const userID = localStorage.getItem("userID");

  //     if (!userName || !userID) {
  //       // console.log("No user data in localStorage, using default date");
  //       return null;
  //     }

  //     const response = await fetch(
  //       "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           UserName: userName,
  //           ID: userID,
  //           UserToken: "",
  //           Token: {
  //             AccessToken:
  //               "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
  //           },
  //         }),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch user data");
  //     }

  //     const data = await response.json();
  //     // console.log("Fetched user data:", data);



  //     // The API returns a Profiles array, get the first element
  //     if (data && data.Profiles && data.Profiles.length > 0) {
  //       const profileData = data.Profiles[0];

  //       // Extract the DOB and format it properly
  //       const dob = profileData.DOB;
  //       // console.log("Extracted DOB from profile:", dob);
        
  //       // Extract gender information
  //       const gender = profileData.Gender; //|| "Male";  Default to Male if not present
  //       // console.log("Extracted gender from profile:", gender);

  //       // Store both properly capitalized and lowercase versions
  //       setUserGender(gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase());

  //       // Set the apiDate state with this DOB
  //       setApiDate(dob);
        
  //       // IMPORTANT: Store the complete profile data including gender
  //       setUserData({
  //         ...profileData,
  //         Gender: gender // Ensure gender is stored in the userData state
  //       });
        
  //       await displayAllCharts(dob);

  //       // Return the chart data structure with gender included
  //       return {
  //         WEALTH: Lwealth, // Default values
  //         CAREER: Lcareer,
  //         RS: Lrs,
  //         HEALTH: Lhealth,
  //         WISDOM: Lwisdom,
  //         DOB: dob,
  //         Gender: gender
  //       };
  //     }

  //     throw new Error("No user profile found");
  //   } catch (error) {
  //     // console.error("Error fetching user data:", error);
  //     return null;
  //   }
  // };

  // // console.log("CRITICAL DATA CHECK:");
  // // console.log("Gender:", userGender);
  // // console.log("Chart Strength:", chartStrengthData);
  // // console.log("Natal Element:", userZodiac.natal);

  const categoryMap = {
    wealth: { apiKey: "WEALTH", displayName: "Wealth Score" },
    health: { apiKey: "HEALTH", displayName: "Health Score" },
    career: { apiKey: "CAREER", displayName: "Career Score" },
    relationship: { apiKey: "RS", displayName: "Relationship Score" },
    wisdom: { apiKey: "WISDOM", displayName: "Wisdom Score" },
  };

  // const displayAllCharts = async (dob) => {
  //   let natalData = null;
  //   try {
  //     // Parse the date from apiDate state
  //     const birthDate = new Date(apiDate || dob);
  //     const year = birthDate.getFullYear();
  //     const month = birthDate.getMonth() + 1;
  //     const day = birthDate.getDate();
  //     const hour = birthDate.getHours();
  //     const minutes = birthDate.getMinutes();

  //     // Format time as HH:MM
  //     const timeString = `${hour.toString().padStart(2, "0")}:${minutes
  //       .toString()
  //       .padStart(2, "0")}`;

  //     // Call API directly instead of using fetchUserData
  //     const response = await fetch(
  //       `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
  //     );

  //     const data = await response.json();
  //     // console.log("All charts API response:", data);

  //     // Check for Tables array
  //     if (data && data.Tables && data.Tables.length > 0) {
  //       // Use only the first table
  //       const firstTable = data.Tables[0];

  //       if (firstTable && firstTable.length > 0) {
  //         natalData = firstTable[0]; // First row of first table
  //       }
  //     } else if (data && data.length > 0) {
  //       // Fallback to old format
  //       natalData = data[0];
  //     }
  //   } catch (error) {
  //     // console.log("Error fetching natal data for charts:", error);
  //   }

    
  //   if (natalData) {
  //     const categories = Object.keys(categoryMap);

  //     // Create chart data for all categories
  //     const charts = categories.map((category) => {
  //       const mapping = categoryMap[category];
  //       const value = natalData[mapping.apiKey] || 0;

  //       return {
  //         category: mapping.apiKey,
  //         label: mapping.displayName.split(" ")[0],
  //         value: value,
  //         title: mapping.displayName,
  //       };
  //     });

  //     setAllCharts(charts);
  //     // console.log("Charts created successfully:", charts);

  //     const chartValues = {
  //       WEALTH: natalData.WEALTH || 0,
  //       CAREER: natalData.CAREER || 0,
  //       RS: natalData.RS || 0,
  //       HEALTH: natalData.HEALTH || 0,
  //       WISDOM: natalData.WISDOM || 0
  //     };

  //     // console.log("Setting userChartValues from displayAllCharts:", chartValues);
  //     setUserChartValues(chartValues);
  //   } else {
  //     // console.log("No natal data available to create charts");

  //     setUserChartValues({
  //       WEALTH: 0,
  //       CAREER: 0,
  //       RS: 0,
  //       HEALTH: 0,
  //       WISDOM: 0
  //     });
  //   }

    
  // };

  
  useEffect(() => {
    checkUserLogin();
    //comment checkuserlogin and uncomment setIsLoggedIn(true) when testing
    // setIsLoggedIn(true);
    // Add this line to fetch keyword mappings
    // fetchKeywordMappings();

    const savedChartStrength = localStorage.getItem("userChartStrength");
    if (savedChartStrength) {
      try {
        const parsedStrength = JSON.parse(savedChartStrength);
        // console.log("Found saved chart strength in localStorage:", parsedStrength);
        setChartStrengthData(parsedStrength);
      } catch (e) {
        // console.error("Error parsing saved chart strength:", e);
      }
    }

    // Load saved natal element from localStorage
    const savedNatal = localStorage.getItem("userNatalElement");
    const savedLunarData = localStorage.getItem("lunarData");
    if (savedLunarData) {
      try {
        const parsedLunarData = JSON.parse(savedLunarData);
        // console.log("Found saved lunar data in localStorage:", parsedLunarData);
        setLunarData(parsedLunarData);
        
        // Add console log to show A1-B4 data status
        // console.log("A1-B4 Data Status:");
        // console.log("A1:", parsedLunarData.A1 || "Not stored");
        // console.log("A2:", parsedLunarData.A2 || "Not stored");
        // console.log("A3:", parsedLunarData.A3 || "Not stored");
        // console.log("A4:", parsedLunarData.A4 || "Not stored");
        // console.log("B1:", parsedLunarData.B1 || "Not stored");
        // console.log("B2:", parsedLunarData.B2 || "Not stored");
        // console.log("B3:", parsedLunarData.B3 || "Not stored");
        // console.log("B4:", parsedLunarData.B4 || "Not stored");
        
        // Check if all A1-B4 values are stored
        const allValues = [
          parsedLunarData.A1, parsedLunarData.A2, parsedLunarData.A3, parsedLunarData.A4,
          parsedLunarData.B1, parsedLunarData.B2, parsedLunarData.B3, parsedLunarData.B4
        ];
        const storedCount = allValues.filter(val => val !== null && val !== undefined).length;
        // console.log(`A1-B4 Storage Summary: ${storedCount}/8 values stored`);
        
      } catch (e) {
        // console.error("Error parsing saved lunar data:", e);
      }
    } else {
      // console.log("No A1-B4 data found in localStorage");
    }
    
    if (savedNatal) {
      // console.log("Found saved natal element in localStorage:", savedNatal);
      
      // Update userZodiac
      setUserZodiac(prev => ({
        ...prev,
        natal: savedNatal
      }));
      
      // Also update lunarData
      setLunarData(prev => ({
        ...prev,
        A2: savedNatal
      }));
    }
    // console.log("State changed - currentCategory:", currentCategory);
    // console.log("State changed - showHelpButton:", showHelpButton);
    // console.log("isOpen state:", isOpen);

    // Create an async function that runs all fetches in sequence
    const fetchAllUserData = async () => {
      try {
        // First fetch basic user data
        const userData = await fetchUserData();
        
        // Then ensure critical data is loaded (chart strength + natal element)
        const criticalDataResult = await ensureCriticalData();
        // console.log("Critical data loaded successfully:", criticalDataResult);
        
        // Then fetch natal charts with small delay to ensure previous data is processed
        // setTimeout(() => {
        //   displayAllCharts();
        // }, 500);
      } catch (error) {
        // console.error("Error fetching initial user data:", error);
      }
    };
    
    // Run the fetch function when chatbot is opened
    if (isOpen) {
      fetchAllUserData();
    }
    
    // Run initial API call only once after data is loaded
    if (!hasMounted.current && isLoggedIn && apiDate) {
      hasMounted.current = true;
      // Ensure all buttons are hidden on startup
      setIsFinal(false);
      setHideInitialQuestions(true);
      setHideCategoryButtons(true);
      setQuestions([]);
      setIsFirstSelection(true);
      setShowHelpButton(false);

      setTimeout(() => {
        fetchResponse("-1");
      }, 500);
    }
  }, [isLoggedIn, currentCategory, showHelpButton, apiDate, isOpen]);

  // If user is not logged in, don't render the chatbot at all
  if (!isLoggedIn) {
    return null; // Return nothing when not logged in
  }

  const handleRestart = () => {
    // Save the current identity data
    const currentGender = userGender;
    const currentNatal = lunarData?.A2;
    const currentChartStrength = chartStrengthData?.category;

    setMessages([]);
    setQuestions([]);
    setIsFinal(false);
    setHideInitialQuestions(true);
    setShowChart(false);
    setShowHelpButton(false);
    setHideCategoryButtons(true);
    setCurrentCategory(null);
    setChartData(null);
    setShowRestartButton(false);
    setAllCharts([]);
    setSuggestedKeywords([]);

    // Pass null as the questionId parameter to reset it
    fetchResponse("-1", null); 

    // Make sure we immediately have the data available
    setTimeout(() => {
      // Only fetch charts but preserve identity data
      // displayAllCharts();
      
      // Make sure the identity data persists
      // console.log("Preserving identity data after restart");
      // console.log("Gender:", currentGender);
      // console.log("Natal Element:", currentNatal);
      // console.log("Chart Strength:", currentChartStrength);
      
      // Double check that identity data wasn't inadvertently reset
      if (!userGender || !lunarData?.A2 || !chartStrengthData?.category) {
        // Restore values if they got reset
        setUserGender(currentGender);
        setLunarData(prev => ({
          ...prev,
          A2: currentNatal // Restore natal element
        }));
        setChartStrengthData(currentChartStrength);
      }
    }, 500);
  };

  // // console.log(`Checking element in userZodiac.natal: "${userZodiac.natal}"`)
  // // console.log(`Character codes:`, [...userZodiac.natal].map(char => char.charCodeAt(0)));

  const fetchZodiacData = async () => {
    if (!apiDate || isNaN(new Date(apiDate).getTime())) {
      // console.error("Invalid apiDate:", apiDate);
      fetchUserData();
    } else {
      setLoading(true);

      try {
        const birthDate = new Date(apiDate);
        const year = birthDate.getFullYear();       
        const month = (birthDate.getMonth() + 1).toString().padStart(2, "0");
        const day = birthDate.getDate().toString().padStart(2, "0");
        const hour = birthDate.getHours();
        const minutes = birthDate.getMinutes();

        // Format time as HH:MM
        const timeString = `${hour.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;

        // Call the API with dynamic birth data
        const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`;

        // Use async/await consistently
      const response = await fetch(url);
      const data = await response.json();
      // console.log("Zodiac API Response:", data);

      if (data && data.length > 0) {
        const zodiacData = data[0];
        const zodiacSign = zodiacData.ZODIAC;
        
        // Store zodiac information in state
        setUserZodiac({
          sign: zodiacSign,
          chineseSign: zodiacData.ZODIAC_CN,
          natal: zodiacData.NATAL || ""
        });
        
        // Make a follow-up API call to get the zodiac-specific options
        const zodiacQueryParam = `userQuery=${encodeURIComponent(zodiacSign)}`;
        const zodiacResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${zodiacQueryParam}`
        );
        
        const zodiacOptionsData = await zodiacResponse.json();
        // console.log("Zodiac-specific options response:", zodiacOptionsData);
        
        // Display the zodiac sign and 2025 forecast
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: "Zodiac 2025" },
          {
            sender: "bot",
            text: `Your Chinese zodiac sign is ${zodiacSign} (${zodiacData.ZODIAC_CN}).
                 2025 ${zodiacSign} Forecast: A Year of Opportunity!`,
          },
        ]);
              
        if (zodiacOptionsData.selection) {
          // Clean up the selection string in case it contains newlines
          const cleanedSelection = zodiacOptionsData.selection.replace(/\n/g, '');
          
          // Parse the selection options 
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log("Zodiac-specific selections:", selections);
          
          // Set the buttons
          setQuestions(selections);
          setHideInitialQuestions(false);
              } else {
                // If no selection options returned, fall back to your default topics
                const topicButtons = [
                  "Education",
                  "General",
                  "Wealth",
                  "Career",
                  "Love & Relationship",
                  "Health",
                ];
              
                setQuestions(
                  topicButtons.map((topic, index) => ({
                    id: index,
                    text: topic,
                  }))
                );
                setHideInitialQuestions(false);
              }

              // Update UI state to show topic buttons
              setHideInitialQuestions(false);
              setHideCategoryButtons(false);
              setIsFinal(false);
              setCurrentCategory(null);
            }
      } catch (error) {
        // console.error("Error in fetchZodiacData:", error);
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: "Zodiac 2025" },
          {
            sender: "bot",
            text: "Sorry, I couldn't retrieve your zodiac information at this time.",
          },
        ]);

        
      } finally {
        setLoading(false);
      }

      // const handleChartStrengthQuery = async () => {
      //   setLoading(true);
      //   const strengthData = await fetchChartStrength();
      //   setLoading(false);
        
      //   if (strengthData) {
      //     // You can use the data for further processing or display
      //     // console.log(`User has a ${strengthData.strengthCategory} chart with value ${strengthData.chartStrength}`);
      //   }
      // };
    }
  };
/*
  const handleZodiacTopicSelection = async (topic) => {
    setLoading(true);

    try {
      let zodiacSign = userZodiac.sign;
    
      if (!zodiacSign) {
        // Parse the date from apiDate state
        const birthDate = new Date(apiDate);
        const year = birthDate.getFullYear();
        const month = birthDate.getMonth() + 1;
        const day = birthDate.getDate();
        const hour = birthDate.getHours();
        const minutes = birthDate.getMinutes();

        // Format time as HH:MM
        const timeString = `${hour.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;

        // Get user's zodiac sign from API with dynamic data
        const zodiacData = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
        ).then((res) => res.json());

        zodiacSign = zodiacData[0]?.ZODIAC || "Unknown";
        
        // Store the zodiac sign
        if (zodiacData[0]) {
          setUserZodiac({
            sign: zodiacSign,
            chineseSign: zodiacData[0].ZODIAC_CN || "",
            natal: zodiacData[0].NATAL || ""
          });
        }
      }


      // Create topic-specific queries with more context
      let query = "";
      switch (topic) {
        case "Education":
          query = `What is the 2025 education forecast for ${zodiacSign}?`;
          break;
        case "General":
          query = `What is the general outlook for ${zodiacSign} in 2025?`;
          break;
        case "Wealth":
          query = `How will ${zodiacSign}'s finances and wealth be in 2025?`;
          break;
        case "Career":
          query = `What career opportunities will ${zodiacSign} have in 2025?`;
          break;
        case "Love & Relationship":
          query = `What is the relationship and romance forecast for ${zodiacSign} in 2025?`;
          break;
        case "Health":
          query = `What health issues should ${zodiacSign} be aware of in 2025?`;
          break;
        default:
          query = `Tell me about ${zodiacSign} ${topic.toLowerCase()} forecast for 2025`;
      }

      // Call the chatbot API with this query
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${encodeURIComponent(
          query
        )}`
      );

      const data = await response.json();

      // For debugging
      // console.log(`Topic: ${topic}, Query: ${query}`);
      // console.log(`API Response:`, data);

      // Add the user's selection and the API response to messages
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: topic },
        {
          sender: "bot",
          text:
            data.answer ||
            `2025 ${topic} Forecast for ${zodiacSign}: Based on Chinese astrology, your ${topic.toLowerCase()} outlook is...`,
        },
      ]);

      // Set final state to show Start Over button
      setIsFinal(true);
      setHideCategoryButtons(true);
      setShowHelpButton(false);
      setShowRestartButton(true);

      // If the API returns follow-up question options, show them
      if (data.selection) {
        // Process selections as before
      } else {
        setQuestions([]);
      }
    } catch (error) {
      // Error handling as before
    }

    setLoading(false);
  };
  */
  

  const handleZodiacKeywordQuery = async (zodiacSign) => {
    try {
      setLoading(true);
      
      // Check if this is coming from a pillar reading context
      const isFromPillarReading = messages.some(msg => 
        msg.sender === "bot" && 
        msg.text && 
        (msg.text.includes("Natal zodiac pillar") || msg.text.includes("pillar readings"))
      );
      
      // If this is from a pillar reading, use a different endpoint or parameter
      let queryParam = '';
      let idParam = '';
      
      if (isFromPillarReading) {
        // Use the correct parent question ID for pillar readings
        queryParam = `userQuery=${encodeURIComponent(zodiacSign)}`;
        idParam = `&questionid=643`;
      } else {
        // Standard zodiac query
        queryParam = `userQuery=${encodeURIComponent(zodiacSign)}`;
      }
      
      // Make API call with the appropriate parameters
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
      );
      
      const data = await response.json();
      // console.log(`Zodiac API response for ${zodiacSign} (from pillar? ${isFromPillarReading}):`, data);
      
      // Add user message and bot response
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: zodiacSign },
        { 
          sender: "bot", 
          text: data.answer || `2025 ${zodiacSign} Forecast: Looking ahead to the Year of the Dragon...` 
        }
      ]);
      
      // For pillar readings, we expect strong/weak pillar options
      if (isFromPillarReading && data.selection) {
        const pillars = data.selection.replace(/\n/g, '').split(',').map((s) => {
          if (s.includes("|")) {
            const [id, text] = s.split("|");
            return { id: id.trim(), text: text.trim() };
          } else {
            return { id: s, text: s.trim() };
          }
        });
        
        // Set the proper pillar buttons from selection
        setQuestions(pillars);
      } else {
        // Use standard zodiac buttons
        const standardSelections = [
          { id: "476", text: "General" },
          { id: "622", text: "Which zodiac sign best to marry one?" },
          { id: "637", text: "Ideal business partner" },
          { id: "638", text: "Which zodiac sign clash with me." }
        ];
        
        // Set the buttons
        setQuestions(standardSelections);
      }
      
      setHideInitialQuestions(false);
      setLoading(false);
    } catch (error) {
      // console.error(`Error processing zodiac keyword ${zodiacSign}:`, error);
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: zodiacSign },
        { sender: "bot", text: `Sorry, I couldn't retrieve information about ${zodiacSign} at this moment.` }
      ]);
      setLoading(false);
    }
  };

  const fetchResponse = async (userQuery, questionId = null) => {
    // console.log("CRITICAL DATA CHECK:");
    // console.log("Gender:", userGender); // Should be "Male" or "Female"
    // console.log("Chart Strength:", chartStrengthData); // Should contain {category: "strong" or "weak"}
    // console.log("Current natal element value:", userZodiac.natal);
    // console.log("Current lunarData.A2 value:", lunarData.A2);
    // console.log("User's Zodiac Sign:", userZodiac.sign);
    // console.log("Natal Element:", lunarData?.A2); // Should be the natal element
    setHideInitialQuestions(true);
    setSuggestedKeywords([]);
    setLoading(true);

    // Add a delay before showing the response
    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (userQuery !== "-1" && 
      !userQuery.toLowerCase().includes("natal") && 
      !Object.keys(categoryMap).includes(userQuery.toLowerCase())) {
      setAllCharts([]);
    }
  
    // Normalize the query for matching
    const normalizedQuery = userQuery.toLowerCase();

    // First check for exact match in keyword mappings (if no questionId is provided)
    if (!questionId) {
      let matchedQuestionId = null;
      // console.log("Current natal element value:", userZodiac.natal);
      // console.log("Current natal element value:", userZodiac.natal);
      // console.log("Current lunarData.A2 value:", lunarData.A2);

      try {
        // Fetch the keyword mappings to check for matches
        const mappingsResponse = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
        const mappingsData = await mappingsResponse.json();
        
        // console.log("Checking for keyword matches with dynamic validation...");
        
        // Get user's current A1-B4 values
        const userA1 = lunarData?.A1;
        const userA2 = lunarData?.A2;
        const userA3 = lunarData?.A3;
        const userA4 = lunarData?.A4;
        const userB1 = lunarData?.B1;
        const userB2 = lunarData?.B2;
        const userB3 = lunarData?.B3;
        const userB4 = lunarData?.B4;
        
        // console.log("User's A1-B4 values:");
        // console.log("A1:", userA1, "A2:", userA2, "A3:", userA3, "A4:", userA4);
        // console.log("B1:", userB1, "B2:", userB2, "B3:", userB3, "B4:", userB4);
        
        // STEP 1: Find all mappings that match the user's query keywords
        let potentialMatches = [];
        
        for (const mapping of mappingsData) {
          if (mapping.KeywordText) {
            // Split keywords and check if any match the user query
            const keywords = mapping.KeywordText.split(',').map(k => k.trim().toLowerCase());
            const userQueryLower = userQuery.toLowerCase().trim();
            
            // Enhanced keyword matching with multiple strategies
            let keywordMatch = false;
            
            // 1. Basic keyword matching (original logic)
            keywordMatch = keywords.some(keyword => 
              userQueryLower.includes(keyword) || keyword.includes(userQueryLower)
            );
            
            // 2. If still no match, try partial matching with individual query words
            if (!keywordMatch) {
              const queryWords = userQueryLower.split(/\s+/).filter(word => word.length > 2);
              
              for (const keyword of keywords) {
                const keywordWords = keyword.split(/\s+/).filter(word => word.length > 2);
                let wordMatchCount = 0;
                
                for (const queryWord of queryWords) {
                  if (keywordWords.some(kw => kw.includes(queryWord) || queryWord.includes(kw))) {
                    wordMatchCount++;
                  }
                }
                
                // If significant word overlap exists
                if (queryWords.length > 0 && wordMatchCount / queryWords.length >= 0.6) {
                  // console.log(`Partial word match: "${keyword}" matches query "${userQueryLower}"`);
                  keywordMatch = true;
                  break;
                }
              }
            }
            
            // 3. Zodiac-specific matching logic (if no basic match found)
            if (!keywordMatch && userZodiac && userZodiac.sign && mapping.Natal) {
              const userZodiacSign = userZodiac.sign.toLowerCase();
              const mappingZodiac = mapping.Natal.toLowerCase();
              
              // console.log(`Checking zodiac context - User: "${userZodiacSign}" vs Mapping: "${mappingZodiac}"`);
              
              // Only proceed if the mapping is for the user's zodiac sign
              if (userZodiacSign === mappingZodiac) {
                // console.log(`Zodiac match found! Checking if query relates to keywords...`);
                
                // Check if the query contains keywords that would make sense for this zodiac-specific mapping
                for (const keyword of keywords) {
                  // Check if significant portions of the keyword appear in the query
                  const keywordParts = keyword.split(/\s+/).filter(part => part.length > 2);
                  let matchCount = 0;
                  
                  for (const part of keywordParts) {
                    if (userQueryLower.includes(part)) {
                      matchCount++;
                    }
                  }
                  
                  // If majority of the keyword parts are in the query
                  if (keywordParts.length > 0 && matchCount / keywordParts.length >= 0.5) {
                    // console.log(`Zodiac context match: User query "${userQuery}" matches keyword "${keyword}" for ${mappingZodiac}`);
                    keywordMatch = true;
                    break;
                  }
                  
                  // Also check for partial matches in reverse (query parts in keyword)
                  const queryParts = userQueryLower.split(/\s+/).filter(part => part.length > 2);
                  let reverseMatchCount = 0;
                  
                  for (const queryPart of queryParts) {
                    if (keyword.includes(queryPart)) {
                      reverseMatchCount++;
                    }
                  }
                  
                  if (queryParts.length > 0 && reverseMatchCount / queryParts.length >= 0.5) {
                    // console.log(`Zodiac context reverse match: Query "${userQuery}" parts found in keyword "${keyword}" for ${mappingZodiac}`);
                    keywordMatch = true;
                    break;
                  }
                }
              }
            }
            
            // If we found a keyword match, add to potential matches
            if (keywordMatch) {
              potentialMatches.push(mapping);
              // console.log(`Added potential match: ID ${mapping.QuestionID}, Keywords: ${mapping.KeywordText}`);
            }
          }
        }
        
        // console.log(`Found ${potentialMatches.length} potential matches`);
        
        // STEP 2: If we have potential matches, find the most specific one
        if (potentialMatches.length > 0) {
          let bestMatch = null;
          let bestSpecificityScore = -1;
          
          for (const mapping of potentialMatches) {
            // console.log(`\nEvaluating match: ID ${mapping.QuestionID}`);
            // console.log(`Mapping - Gender: ${mapping.Gender}, Strength: ${mapping.Strength}, Natal: ${mapping.Natal}, Symbol: ${mapping.Symbol}`);
            
            let specificityScore = 0;
            let isValidMatch = true;

            // NEW VALIDATION: Check QuestionText and handle periods
            if (mapping.QuestionText) {
              // Remove periods and trailing/leading spaces, then convert to lowercase
              const normalizedUserQuery = userQuery.replace(/\./g, '').trim().toLowerCase();
              const normalizedQuestionText = mapping.QuestionText.replace(/\./g, '').trim().toLowerCase();
              
              const hasGeneral = normalizedQuestionText.includes('general');
                                      
              // Reject mappings that are NOT "general" when doing keyword matching
              if (!hasGeneral) {
                // console.log(`âŒ Rejecting ID ${mapping.QuestionID}: QuestionText is not "general" ("${normalizedQuestionText}")`);
                
                // Track that we rejected it specifically because it lacked "general"
                mapping.failedDueToNotGeneral = true;
                isValidMatch = false;
                continue;
              }

              // Evaluate Exact string vs General query match points
              if (normalizedUserQuery === normalizedQuestionText) {
                // console.log(`âœ… QuestionText exact match found (ignoring periods): "${normalizedQuestionText}"`);
                // Check if it's strictly EXACT match over generic text: "general".
                specificityScore += 20; // Give a huge score boost for an exact question match
              } else if (hasGeneral) {
                // console.log(`âœ… QuestionText match based on generic requirement: "${normalizedQuestionText}"`);
                specificityScore += 10; // Boost score so it can display the answer
              }
            }

            if (mapping.KeywordText) {
              const mappingKeywords = mapping.KeywordText.split(',').map(k => k.trim().toLowerCase());
              const userQueryLower = userQuery.toLowerCase().trim();
              
              let keywordMatchedCount = 0;
              for (const kw of mappingKeywords) {
                // Ignore tiny generic words, check if the specific word is in the query
                if (kw.length > 2 && userQueryLower.includes(kw)) {
                  keywordMatchedCount++;
                }
              }
              
              // Add +5 to the score for EVERY keyword matched. 
              // Example: "improve wealth" matches "improve" (+5) AND "wealth" (+5) = 10 points
              if (keywordMatchedCount > 0) {
                specificityScore += (keywordMatchedCount * 5);
                // console.log(`ðŸ”‘ Keyword specific match: +${keywordMatchedCount * 5} score (${keywordMatchedCount} keywords matched: e.g. wealth, health, etc.)`);
              }
            }
            
            // Check if this mapping requires A1-B4 natal element validation
            let requiresNatalElementValidation = false;
            let natalRequirements = [];
            
            if (mapping.Natal && mapping.Natal.trim() !== "") {
              // Parse the Natal field to see if it contains A1-B4 references
              natalRequirements = mapping.Natal.split(',').map(n => n.trim());
              
              // Check if any of the requirements are A1-B4 values
              const a1b4Fields = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
              requiresNatalElementValidation = natalRequirements.some(req => a1b4Fields.includes(req));
              
              // console.log(`Natal requirements: ${natalRequirements.join(', ')}`);
              // console.log(`Requires A1-B4 validation: ${requiresNatalElementValidation}`);
            }
            
            // GENDER VALIDATION
            if (mapping.Gender !== -1) {
              const userGenderCode = userGender?.toLowerCase() === "male" ? 0 : 1;
              if (mapping.Gender === userGenderCode) {
                specificityScore += 10; // High score for gender match
                // console.log(`âœ… Gender match: User ${userGender} (${userGenderCode}) = Mapping ${mapping.Gender}`);
              } else {
                // console.log(`âŒ Gender mismatch: User ${userGender} (${userGenderCode}) â‰  Mapping ${mapping.Gender}`);
                isValidMatch = false;
              }
            } else {
              // console.log(`âšª Gender: Not specified in mapping (accepts any)`);
            }

              if (!isValidMatch) {
                // console.log(`â­ï¸ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
                continue;
              }
            
            // STRENGTH VALIDATION
            if (mapping.Strength !== -1) {
              const userStrengthCode = chartStrengthData?.category === "strong" ? 0 : 1;
              if (mapping.Strength === userStrengthCode) {
                specificityScore += 10; // High score for strength match
                // console.log(`âœ… Strength match: User ${chartStrengthData?.category} (${userStrengthCode}) = Mapping ${mapping.Strength}`);
              } else {
                // console.log(`âŒ Strength mismatch: User ${chartStrengthData?.category} (${userStrengthCode}) â‰  Mapping ${mapping.Strength}`);
                isValidMatch = false;
              }
            } else {
              // console.log(`âšª Strength: Not specified in mapping (accepts any)`);
            }
            
              if (!isValidMatch) {
              // console.log(`â­ï¸ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
              continue;
            }
            // NATAL/SYMBOL VALIDATION
            if (requiresNatalElementValidation) {
              // console.log("ðŸ” A1-B4 natal element validation required");
              
              if (mapping.Symbol && mapping.Symbol.trim() !== "") {
                // Parse the symbol to get the values to match
                // Handle both single values and comma-separated values
                const symbolParts = mapping.Symbol.includes(',') 
                  ? mapping.Symbol.split(',').map(s => s.trim())
                  : mapping.Symbol.split('.').map(s => s.trim());
                
                // console.log("Symbol parts:", symbolParts);
                // console.log("Natal requirements:", natalRequirements);
                
                // Check if we have the required natal values based on the Natal field
                let allRequiredValuesMatch = true;
                
                // Handle the case where we have multiple symbols for the same natal requirement
                if (symbolParts.length > natalRequirements.length) {
                  // console.log("Multiple symbols found for natal requirements");
                  
                  // For each natal requirement, check if any of the symbols match
                  for (let i = 0; i < natalRequirements.length; i++) {
                    const requirement = natalRequirements[i];
                    let userValue = null;
                    
                    // Get the user's value based on the requirement
                    switch (requirement) {
                      case 'A1': userValue = lunarData?.A1; break;
                      case 'A2': userValue = lunarData?.A2; break;
                      case 'A3': userValue = lunarData?.A3; break;
                      case 'A4': userValue = lunarData?.A4; break;
                      case 'B1': userValue = lunarData?.B1; break;
                      case 'B2': userValue = lunarData?.B2; break;
                      case 'B3': userValue = lunarData?.B3; break;
                      case 'B4': userValue = lunarData?.B4; break;
                      default:
                        // console.log(`âŒ Unknown A1-B4 requirement: ${requirement}`);
                        allRequiredValuesMatch = false;
                        continue;
                    }
                    
                    const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                    
                    // Check if the user value matches ANY of the symbols
                    let requirementMatched = false;
                    
                    for (const symbolValue of symbolParts) {
                      const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                      const cleanSymbolValue = symbolValue ? symbolValue.toString().trim().replace(/\s+/g, '') : '';
                      
                      // Enhanced matching logic - now ignores all spaces
                      let valueMatch = false;
                      
                      if (cleanUserValue && cleanSymbolValue) {
                        // Remove all spaces from both values for comparison
                        const spacefreUserValue = cleanUserValue.replace(/\s/g, '');
                        const spacefreSymbolValue = cleanSymbolValue.replace(/\s/g, '');
                        
                        // Try multiple matching strategies with space-free values
                        valueMatch = spacefreUserValue === spacefreSymbolValue ||
                                    spacefreUserValue.includes(spacefreSymbolValue) ||
                                    spacefreSymbolValue.includes(spacefreUserValue) ||
                                    spacefreUserValue.toLowerCase() === spacefreSymbolValue.toLowerCase();
                      }
                      
                      // console.log(`${requirement}: User="${cleanUserValue}" vs Symbol="${cleanSymbolValue}" = ${valueMatch ? 'âœ…' : 'âŒ'}`);
                      
                      if (valueMatch) {
                        // console.log(`âœ… ${requirement}: User="${cleanUserValue}" matches Symbol="${cleanSymbolValue}"`);
                        requirementMatched = true;
                        specificityScore += 5; // Medium score for each natal element match
                        break; // Found a match, no need to check other symbols
                      }
                    }
                    
                    if (!requirementMatched) {
                      // console.log(`âŒ ${requirement}: User="${cleanUserValue}" doesn't match any symbols: ${symbolParts.join(', ')}`);
                      allRequiredValuesMatch = false;
                    }
                  }
                } else {
                  // Original logic for 1:1 mapping between natal requirements and symbols
                  for (let i = 0; i < natalRequirements.length; i++) {
                    const requirement = natalRequirements[i];
                    const symbolValue = symbolParts[i];
                    
                    let userValue = null;
                    
                    // Get the user's value based on the requirement
                    switch (requirement) {
                      case 'A1': userValue = lunarData?.A1; break;
                      case 'A2': userValue = lunarData?.A2; break;
                      case 'A3': userValue = lunarData?.A3; break;
                      case 'A4': userValue = lunarData?.A4; break;
                      case 'B1': userValue = lunarData?.B1; break;
                      case 'B2': userValue = lunarData?.B2; break;
                      case 'B3': userValue = lunarData?.B3; break;
                      case 'B4': userValue = lunarData?.B4; break;
                      default:
                        // console.log(`âŒ Unknown A1-B4 requirement: ${requirement}`);
                        allRequiredValuesMatch = false;
                        continue;
                    }
                    
                    // Clean and normalize both values for comparison
                    const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                    const cleanSymbolValue = symbolValue ? symbolValue.toString().trim().replace(/\s+/g, '') : '';
                    
                    // Enhanced matching logic
                    let valueMatch = false;
                    
                    if (cleanUserValue && cleanSymbolValue) {
                      // Try multiple matching strategies
                      valueMatch = cleanUserValue === cleanSymbolValue ||
                                  cleanUserValue.includes(cleanSymbolValue) ||
                                  cleanSymbolValue.includes(cleanUserValue) ||
                                  cleanUserValue.toLowerCase() === cleanSymbolValue.toLowerCase();
                    }
                    
                    // console.log(`${requirement}: User="${cleanUserValue}" vs Symbol="${cleanSymbolValue}" = ${valueMatch ? 'âœ…' : 'âŒ'}`);
                    
                    if (valueMatch) {
                      specificityScore += 5; // Medium score for each natal element match
                    } else {
                      allRequiredValuesMatch = false;
                    }
                  }
                }
                
                if (!allRequiredValuesMatch) {
                  // console.log("âŒ A1-B4 symbol/natal element validation failed");
                  isValidMatch = false;
                } else {
                  // console.log("âœ… All A1-B4 symbol/natal elements match");
                }
              } else {
                // console.log("âšª A1-B4 validation required but no symbol provided in mapping");
              }
            } else {
              // Not A1-B4 validation, check for zodiac sign matching
              if (mapping.Natal && userZodiac && userZodiac.sign) {
                const mappingNatal = mapping.Natal.toLowerCase();
                const userZodiacLower = userZodiac.sign.toLowerCase();
                
                if (mappingNatal === userZodiacLower) {
                  specificityScore += 5; // Medium score for zodiac match
                  // console.log(`âœ… Zodiac match: User "${userZodiacLower}" = Mapping "${mappingNatal}"`);
                } else {
                  // console.log(`âŒ Zodiac mismatch: User "${userZodiacLower}" â‰  Mapping "${mappingNatal}"`);
                  isValidMatch = false;
                }
              } else {
                // console.log(`âšª Zodiac: Not specified or not available`);
              }
            }

              if (!isValidMatch) {
              // console.log(`â­ï¸ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
              continue;
            }
            
            if (mapping.PercentBracket && mapping.PercentBracket.trim() !== "") {
              // console.log(`âŒ Rejecting ID ${mapping.QuestionID}: Contains PercentBracket "${mapping.PercentBracket}"`);
              isValidMatch = false;
            } else {
              // console.log(`âœ… Allowed ID ${mapping.QuestionID}: No PercentBracket constraint`);
            }

            if (!isValidMatch) {
              // console.log(`â­ï¸ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
              continue;
            }

            // if (mapping.PercentBracket && mapping.PercentBracket.trim() !== "") {
            //   // console.log("ðŸ” PercentBracket validation required");
              
            //   // Parse the PercentBracket - format: "min, max" or single value
            //   const bracketParts = mapping.PercentBracket.split(',').map(s => s.trim());
            //   let minPercent = 0;
            //   let maxPercent = 100;
              
            //   if (bracketParts.length === 2) {
            //     minPercent = parseInt(bracketParts[0]) || 0;
            //     maxPercent = parseInt(bracketParts[1]) || 100;
            //   } else if (bracketParts.length === 1) {
            //     const singleValue = parseInt(bracketParts[0]) || 0;
            //     minPercent = singleValue;
            //     maxPercent = singleValue;
            //   }
              
            //   // console.log(`PercentBracket range: ${minPercent} - ${maxPercent}`);
              
            //   // Check if we need to validate against specific chart categories
            //   let categoryToCheck = null;
              
            //   if (mapping.KeywordText) {
            //     const keywords = mapping.KeywordText.toLowerCase();
            //     if (keywords.includes('wealth')) {
            //       categoryToCheck = 'WEALTH';
            //     } else if (keywords.includes('career')) {
            //       categoryToCheck = 'CAREER';
            //     } else if (keywords.includes('health')) {
            //       categoryToCheck = 'HEALTH';
            //     } else if (keywords.includes('rs')) {
            //       categoryToCheck = 'RS';
            //     } else if (keywords.includes('wisdom')) {
            //       categoryToCheck = 'WISDOM';
            //     }
            //   }
              
            //   // Validate against the appropriate category
            //   if (categoryToCheck && userChartValues[categoryToCheck] !== undefined) {
            //     const userValue = userChartValues[categoryToCheck];
            //     // console.log(`Checking ${categoryToCheck}: User value ${userValue} against range ${minPercent}-${maxPercent}`);
                
            //     const isWithinRange = userValue >= minPercent && userValue <= maxPercent;
                
            //     if (isWithinRange) {
            //       specificityScore += 8;
            //       // console.log(`âœ… PercentBracket match: ${categoryToCheck} value ${userValue} is within range ${minPercent}-${maxPercent}`);
            //     } else {
            //       // console.log(`âŒ PercentBracket mismatch: ${categoryToCheck} value ${userValue} is NOT within range ${minPercent}-${maxPercent}`);
            //       isValidMatch = false;
            //     }
            //   } else {
            //     // Check if ANY category falls within the range
            //     const allCategories = ['WEALTH', 'CAREER', 'RS', 'HEALTH', 'WISDOM'];
            //     let anyMatchFound = false;
                
            //     for (const category of allCategories) {
            //       const userValue = userChartValues[category];
            //       if (userValue >= minPercent && userValue <= maxPercent) {
            //         // console.log(`âœ… PercentBracket match found: ${category} value ${userValue} is within range ${minPercent}-${maxPercent}`);
            //         anyMatchFound = true;
            //         specificityScore += 5;
            //         break;
            //       }
            //     }
                
            //     if (!anyMatchFound) {
            //       // console.log(`âŒ PercentBracket mismatch: No category values fall within range ${minPercent}-${maxPercent}`);
            //       // console.log("User chart values:", userChartValues);
            //       isValidMatch = false;
            //     }
            //   }
            // } else {
            //   // console.log(`âšª PercentBracket: Not specified in mapping`);
            // }
            
            // FINAL EVALUATION: Only consider this mapping if it's still valid
            // console.log(`Final evaluation - ID ${mapping.QuestionID}: Valid=${isValidMatch}, Score=${specificityScore}`);
            
            if (isValidMatch && specificityScore > bestSpecificityScore) {
              bestMatch = mapping;
              bestSpecificityScore = specificityScore;
              // console.log(`ðŸŽ¯ NEW BEST MATCH: ID ${mapping.QuestionID} with score ${specificityScore}`);
            } else if (!isValidMatch) {
              // console.log(`âŒ REJECTED: ID ${mapping.QuestionID} - failed validation`);
            } else {
              // console.log(`âšª LOWER SCORE: ID ${mapping.QuestionID} - score ${specificityScore} vs current best ${bestSpecificityScore}`);
            }
          }
          
          // STEP 3: Use the best match if found
          if (bestMatch) {
            // console.log(`ðŸ† Final best match: ID ${bestMatch.QuestionID} with score ${bestSpecificityScore}`);
            // console.log(`Using mapping: ${bestMatch.QuestionText}`);
            
            // NEW: Check if the best match score is 0 - this means keyword matched but no valid attributes
            if (bestSpecificityScore === 0) {
              // console.log("âŒ Best match has 0 score - keyword found but no matching attributes");
              
              // Show sorry message for keyword with no valid configuration
              setMessages((prev) => [
                ...prev,
                { sender: "user", text: userQuery },
                { 
                  sender: "bot", 
                  text: `Sorry, I don't have specific information about "${userQuery}" for your natal configuration. Here are some topics you might be interested in:` 
                }
              ]);
              
              // Fetch and show the -1 API selection buttons
              try {
                const fallbackResponse = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${encodeURIComponent("-1")}`
                );
                
                const fallbackData = await fallbackResponse.json();
                // console.log("Fallback -1 response for 0 score match:", fallbackData);
                
                if (fallbackData.selection) {
                  const cleanedSelection = fallbackData.selection.replace(/\n/g, '');
                  const fallbackOptions = cleanedSelection.split(',')
                    .filter(s => s.trim())
                    .map((s) => {
                      if (s.includes("|")) {
                        const [id, text] = s.split("|");
                        return { id: id.trim(), text: text.trim() };
                      } else {
                        return { id: s, text: s.trim() };
                      }
                    });
                  
                  setQuestions(fallbackOptions);
                  setHideInitialQuestions(false);
                } else {
                  // Hardcoded fallback if -1 API doesn't return selections
                  setQuestions([
                    { id: "402", text: "This year zodiac reading" },
                    { id: "629", text: "Find out more about myself male" },
                    { id: "630", text: "Find out more about myself female" },
                    { id: "643", text: "Natal zodiac pillar readings" },
                    { id: "709", text: "Find out about my natal" }
                  ]);
                  setHideInitialQuestions(false);
                }
              } catch (fallbackError) {
                // console.error("Error fetching fallback options for 0 score match:", fallbackError);
                
                // Final hardcoded fallback
                setQuestions([
                  { id: "402", text: "This year zodiac reading" },
                  { id: "629", text: "Find out more about myself male" },
                  { id: "630", text: "Find out more about myself female" },
                  { id: "643", text: "Natal zodiac pillar readings" },
                  { id: "709", text: "Find out about my natal" }
                ]);
                setHideInitialQuestions(false);
              }
              
              setIsFinal(false);
              setLoading(false);
              setInput("");
              return;
            }
            
            // Original logic for matches with score > 0
            // Add user message and show the answer directly
            setMessages((prev) => [
              ...prev,
              { sender: "user", text: userQuery },
              { sender: "bot", text: bestMatch.AnswerText }
            ]);
            
            // Handle selections if any - BUT only if it's NOT final
            if (bestMatch.Selection && bestMatch.IsFinal !== 1) {
              const selections = bestMatch.Selection.split(',').map((s, index) => {
                if (s.includes("|")) {
                  const [id, text] = s.split("|");
                  return { id: id.trim(), text: text.trim() };
                } else {
                  return { id: index, text: s.trim() };
                }
              });
              
              setQuestions(selections);
              setHideInitialQuestions(false);
            } else {
              setQuestions([]);
              setHideInitialQuestions(true);
            }
            
            setIsFinal(bestMatch.IsFinal === 1);
            setLoading(false);
            setInput("");
            return;
          } else {
            // console.log("âŒ No valid matches found after validation");
            
            // NEW: Handle the case where keyword exists but no matching natal/attributes
            // Check if any mapping had the keyword but failed validation
            let hadKeywordButFailedValidation = false;
            
            for (const mapping of potentialMatches) {
              // console.log(`Checking failed validation for mapping ${mapping.QuestionID}`);
              
              // Check if this mapping failed due to natal/symbol validation
              let requiresNatalElementValidation = false;
              let natalRequirements = [];
              
              if (mapping.Natal && mapping.Natal.trim() !== "") {
                natalRequirements = mapping.Natal.split(',').map(n => n.trim());
                const a1b4Fields = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
                requiresNatalElementValidation = natalRequirements.some(req => a1b4Fields.includes(req));
              }
              
              if (requiresNatalElementValidation) {
                // Check if this failed due to natal element mismatch
                let failedNatalValidation = false;
                
                if (mapping.Symbol && mapping.Symbol.trim() !== "") {
                  const symbolParts = mapping.Symbol.split('.');
                  
                  for (let i = 0; i < natalRequirements.length; i++) {
                    const requirement = natalRequirements[i];
                    const symbolValue = symbolParts[i];
                    
                    let userValue = null;
                    switch (requirement) {
                      case 'A1': userValue = lunarData?.A1; break;
                      case 'A2': userValue = lunarData?.A2; break;
                      case 'A3': userValue = lunarData?.A3; break;
                      case 'A4': userValue = lunarData?.A4; break;
                      case 'B1': userValue = lunarData?.B1; break;
                      case 'B2': userValue = lunarData?.B2; break;
                      case 'B3': userValue = lunarData?.B3; break;
                      case 'B4': userValue = lunarData?.B4; break;
                    }
                    
                    const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                    const cleanSymbolValue = symbolValue ? symbolValue.toString().trim().replace(/\s+/g, '') : '';
                    
                    if (cleanUserValue && cleanSymbolValue) {
                      const valueMatch = cleanUserValue === cleanSymbolValue ||
                                      cleanUserValue.includes(cleanSymbolValue) ||
                                      cleanSymbolValue.includes(cleanUserValue) ||
                                      cleanUserValue.toLowerCase() === cleanSymbolValue.toLowerCase();
                      
                      if (!valueMatch) {
                        failedNatalValidation = true;
                        // console.log(`Mapping ${mapping.QuestionID} failed natal validation: ${requirement} "${cleanUserValue}" â‰  "${cleanSymbolValue}"`);
                        break;
                      }
                    }
                  }
                }
                
                if (failedNatalValidation) {
                  hadKeywordButFailedValidation = true;
                  // console.log(`Found keyword match but failed natal validation for mapping ${mapping.QuestionID}`);
                  break;
                }
              }
              
              // Also check for zodiac validation failures
              if (mapping.Natal && userZodiac && userZodiac.sign) {
                const mappingNatal = mapping.Natal.toLowerCase();
                const userZodiacLower = userZodiac.sign.toLowerCase();
                
                if (mappingNatal !== userZodiacLower && !requiresNatalElementValidation) {
                  hadKeywordButFailedValidation = true;
                  // console.log(`Found keyword match but failed zodiac validation for mapping ${mapping.QuestionID}`);
                  break;
                }
              }

              // Also check if they failed because they lacked "general" in QuestionText
              if (mapping.failedDueToNotGeneral) {
                hadKeywordButFailedValidation = true;
                // console.log(`Found keyword match but lacked "general" in QuestionText for mapping ${mapping.QuestionID}`);
                break;
              }
            }
            
            if (hadKeywordButFailedValidation) {
              // console.log("Keyword found but no matching configuration or general questiontext for user's attributes");
              
              if (potentialMatches.some(m => m.failedDueToNotGeneral)) {
                // If it failed specifically because it lacked "general", use the suggested keywords approach
                let fallbackSuggestions = [];
                try {
                  const getKeyResp = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
                  const getKeysData = await getKeyResp.json();
                  
                  const uniqueKeywords = new Set();
                  getKeysData.forEach((mapping) => {
                    const hasNoPeriod = mapping.QuestionText && !mapping.QuestionText.includes(".");
                    const isGeneral = mapping.QuestionText && mapping.QuestionText.toLowerCase().includes("general");
                    const hasNoPercentBracket = !mapping.PercentBracket || mapping.PercentBracket.trim() === "";
                    
                    if (mapping.KeywordText && hasNoPeriod && hasNoPercentBracket && isGeneral) {
                      mapping.KeywordText.split(",").forEach((kw) => {
                        const cleanedKeyword = kw.trim().toLowerCase();
                        if (cleanedKeyword) {
                          uniqueKeywords.add(cleanedKeyword);
                        }
                      });
                    }
                  });
                  
                  fallbackSuggestions = Array.from(uniqueKeywords).slice(0, 50);
                } catch (keyErr) {
                  // console.log("Error fetching getKey keywords for suggestions:", keyErr);
                  fallbackSuggestions = [
                    "wealth",
                    "career",
                    "health",
                    "wisdom",
                    "relationship",
                  ];
                }
                
                setSuggestedKeywords(
                  fallbackSuggestions.map((keyword) => ({
                    id: keyword,
                    text: keyword,
                  }))
                );
                setSuggestionPage(0);
                
                setMessages((prev) => [
                  ...prev,
                  { sender: "user", text: userQuery },
                  { 
                    sender: "bot", 
                    text: "Keyword not recognized. Try one of the suggestions below." 
                  }
                ]);
                
                setQuestions([]);
                setHideInitialQuestions(true);
                setLoading(false);
                setInput("");
                return;
              }

              // Standard missing context message 
              let fallbackText = `Sorry, I don't have specific information about "${userQuery}" for your natal configuration. Here are some topics you might be interested in:`;
              

              // Show sorry message for this specific case
              setMessages((prev) => [
                ...prev,
                { sender: "user", text: userQuery },
                { 
                  sender: "bot", 
                  text: fallbackText 
                }
              ]);
              
              // Fetch and show the -1 API selection buttons
              try {
                const fallbackResponse = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${encodeURIComponent("-1")}`
                );
                
                const fallbackData = await fallbackResponse.json();
                // console.log("Fallback -1 response for keyword without match:", fallbackData);
                
                if (fallbackData.selection) {
                  const cleanedSelection = fallbackData.selection.replace(/\n/g, '');
                  const fallbackOptions = cleanedSelection.split(',')
                    .filter(s => s.trim())
                    .map((s) => {
                      if (s.includes("|")) {
                        const [id, text] = s.split("|");
                        return { id: id.trim(), text: text.trim() };
                      } else {
                        return { id: s, text: s.trim() };
                      }
                    });
                  
                  setQuestions(fallbackOptions);
                  setHideInitialQuestions(false);
                } else {
                  // Hardcoded fallback if -1 API doesn't return selections
                  setQuestions([
                    { id: "402", text: "This year zodiac reading" },
                    { id: "629", text: "Find out more about myself male" },
                    { id: "630", text: "Find out more about myself female" },
                    { id: "643", text: "Natal zodiac pillar readings" },
                    { id: "709", text: "Find out about my natal" }
                  ]);
                  setHideInitialQuestions(false);
                }
              } catch (fallbackError) {
                // console.error("Error fetching fallback options:", fallbackError);
                
                // Final hardcoded fallback
                setQuestions([
                  { id: "402", text: "This year zodiac reading" },
                  { id: "629", text: "Find out more about myself male" },
                  { id: "630", text: "Find out more about myself female" },
                  { id: "643", text: "Natal zodiac pillar readings" },
                  { id: "709", text: "Find out about my natal" }
                ]);
                setHideInitialQuestions(false);
              }
              
              setIsFinal(false);
              setLoading(false);
              setInput("");
              return;
            }
          }
        }
        
        // console.log("No keyword match found - proceeding with normal flow");
        
      } catch (error) {
        // console.error("Error in keyword matching:", error);
      }
    
  
      // If we found a mapping, use it as our questionId
      // if (matchedQuestionId) {
      //   // console.log(`Using keyword mapping: ${matchedQuestionId} for query: ${userQuery}`);
      //   questionId = matchedQuestionId;
      // }
      /*
      if (normalizedQuery === "what is my character" || 
        normalizedQuery === "what is my character?") {
      // Force it to use the same keyword mapping as "my character"
      matchedQuestionId = keywordMappings["my character"];
      // console.log("Normalized 'what is my character' to use mapping:", matchedQuestionId);
      }

      if (chartStrengthData && chartStrengthData.rawValue > 0) {
        const isStrongChart = chartStrengthData.category === "strong";
        
        // Money luck detection
        if (normalizedQuery.includes("money luck") || 
            normalizedQuery.includes("money") || 
            normalizedQuery.includes("wealth luck")) {
          
          // Direct to the appropriate strong/weak money luck ID
          questionId = isStrongChart ? "695" : "696"; // IDs for Strong/Weak Money Luck
          // console.log(`Chart strength detected as ${chartStrengthData.category}, routing money luck query to questionId: ${questionId}`);
        }
        
        // Career luck detection
        else if (normalizedQuery.includes("career luck") || 
                 normalizedQuery.includes("career")) {
          
          // Direct to the appropriate strong/weak career luck ID
          questionId = isStrongChart ? "698" : "699"; // IDs for Strong/Weak Career Luck
          // console.log(`Chart strength detected as ${chartStrengthData.category}, routing career luck query to questionId: ${questionId}`);
        }
        
        // Character detection
        else if (normalizedQuery.includes("character") || 
                 normalizedQuery.includes("my character")) {
          
          // Direct to the appropriate strong/weak character ID
          questionId = isStrongChart ? "692" : "693"; // IDs for Strong/Weak Character
          // console.log(`Chart strength detected as ${chartStrengthData.category}, routing character query to questionId: ${questionId}`);
        }
      }
      */

      // const isSelfIdentityQuery = selfIdentityKeywords.some(keyword => 
      //   normalizedQuery.includes(keyword)
      // );

      // if (normalizedQuery === "who am i?" || normalizedQuery === "who am i" || isSelfIdentityQuery) {
      //   try {
      //     // Debug the values being used
      //     // console.log("Critical values for identity query:");
      //     // console.log("Gender:", userGender); 
      //     // console.log("Chart Strength:", chartStrengthData);
      //     // console.log("Natal Element:", userZodiac.natal);
          
      //     // Add user's query to messages first
      //     setMessages((prev) => [
      //       ...prev,
      //       { sender: "user", text: userQuery }
      //     ]);
          
      //     // Check if we have enough data for a proper identity query
      //     if (!userZodiac.natal || userZodiac.natal === "") {
      //       // If we don't have natal element information, ask the user for it
      //       setMessages((prev) => [
      //         ...prev,
      //         { 
      //           sender: "bot", 
      //           text: "To tell you about yourself, I need to know your element. What's your natal element?" 
      //         }
      //       ]);
            
      //       // Make API call to get element options
      //       const natalResponse = await fetch(
      //         `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=natal`
      //       );
            
      //       const natalData = await natalResponse.json();
            
      //       if (natalData && natalData.selection) {
      //         const cleanedSelection = natalData.selection.replace(/\n/g, '');
      //         const natalOptions = cleanedSelection.split(',').map((s) => {
      //           if (s.includes("|")) {
      //             const [id, text] = s.split("|");
      //             return { id: id.trim(), text: text.trim() };
      //           } else {
      //             return { id: s, text: s.trim() };
      //           }
      //         });
              
      //         setQuestions(natalOptions);
      //         setHideInitialQuestions(false);
      //       }
            
      //       setLoading(false);
      //       setInput("");
      //       return;
      //     }
          
      //     // Force defaults if any data is missing
      //     const effectiveGender = userGender || "Male";
      //     const effectiveStrength = chartStrengthData.category || "strong";
          
      //     // Make sure we have valid chart strength data
      //     let isStrongChart = effectiveStrength === "strong";
          
      //     // Get the targetId based on user's attributes
      //     const targetId = getCharacterTargetId(
      //       effectiveGender, 
      //       userZodiac.natal, 
      //       { category: isStrongChart ? "strong" : "weak" }
      //     );
          
      //     // console.log(`Self/Identity query detected. Using targetId: ${targetId}`);
          
      //     // Make the API call with the determined ID - IMPORTANT: Use "myself" as the keyword
      //     if (targetId) {
      //       const queryParam = `userQuery=myself`;
      //       const idParam = `&questionid=${targetId}`;
            
      //       // console.log(`Making identity API call: ${queryParam}${idParam}`);
            
      //       const response = await fetch(
      //         `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
      //       );
            
      //       const data = await response.json();
      //       // console.log(`Identity API response with ID ${targetId}:`, data);
            
      //       // Add bot response
      //       setMessages((prev) => [
      //         ...prev,
      //         { sender: "bot", text: data.answer || "Here's insight about your character..." }
      //       ]);
            
      //       // Handle selections if any
      //       if (data.selection) {
      //         const cleanedSelection = data.selection.replace(/\n/g, '');
      //         const selections = cleanedSelection.split(',').map((s) => {
      //           if (s.includes("|")) {
      //             const [id, text] = s.split("|");
      //             return { id: id.trim(), text: text.trim() };
      //           } else {
      //             return { id: s, text: s.trim() };
      //           }
      //         });
              
      //         setQuestions(selections);
      //         setHideInitialQuestions(false);
      //       } else {
      //         setQuestions([]);
      //         setHideInitialQuestions(true);
      //       }
            
      //       setIsFinal(data.isfinal === 1);
      //     } else {
      //       // Fallback if no targetId could be determined
      //       setMessages((prev) => [
      //         ...prev,
      //         { 
      //           sender: "bot", 
      //           text: "I'm having trouble determining your character profile. Please try asking about your natal element first." 
      //         }
      //       ]);
      //     }
          
      //     setLoading(false);
      //     setInput("");
      //     return;
      //   } catch (error) {
      //     // console.error("Error in identity/character detection:", error);
      //     // Fall back to regular API call
      //     setMessages((prev) => [
      //       ...prev,
      //       { 
      //         sender: "bot", 
      //         text: "I had trouble analyzing your character. Let's try a different approach." 
      //       }
      //     ]);
          
      //     setLoading(false);
      //     setInput("");
      //     return;
      //   }
      // }
      // Inside your fetchResponse function, update the identity detection block:

    // if (normalizedQuery === "myself" || normalizedQuery === "who am i" || 
    //     selfIdentityKeywords.some(keyword => normalizedQuery.includes(keyword))) {
    // if (selfIdentityKeywords.some(keyword => normalizedQuery.includes(keyword))) {
      
    //   setMessages((prev) => [
    //     ...prev,
    //     { sender: "user", text: userQuery }
    //   ]);
      
    //   try {
    //     // Ensure we have all three required attributes
    //     if (!userGender || !chartStrengthData?.category || !lunarData?.A2) {
    //       // console.log("MISSING REQUIRED DATA:");
    //       // console.log("- Gender:", userGender || "MISSING");
    //       // console.log("- Chart Strength:", chartStrengthData?.category || "MISSING");
    //       // console.log("- Natal Element:", lunarData?.A2 || "MISSING");
          
    //       setMessages((prev) => [
    //         ...prev,
    //         { 
    //           sender: "bot", 
    //           text: "Sorry, I need to know your gender, natal element, and chart strength to analyze your character accurately. Some information is missing." 
    //         }
    //       ]);
    //       setLoading(false);
    //       setInput("");
    //       return;
    //     }
        
    //     // Fetch the keyword mappings directly
    //     const mappingsResponse = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
    //     const mappingsData = await mappingsResponse.json();
        
    //     // console.log("Full mappings data loaded, entries:", mappingsData.length);
        
    //     // Convert gender and strength to match the expected format from the API
    //     // In API: Gender = 0 is male, Gender = 1 is female
    //     // In API: Strength = 0 is strong, Strength = 1 is weak
    //     const genderCode = userGender.toLowerCase() === "male" ? 0 : 1;
    //     const strengthCode = chartStrengthData?.category === "strong" ? 0 : 1;
    //     const symbolToMatch = lunarData?.A2;
        
    //     // console.log(`Looking for EXACT match with: Gender=${genderCode} (${userGender}), Element=${symbolToMatch}, Strength=${strengthCode} (${chartStrengthData?.category})`);
        
    //     // Find the matching entry in the mappings data
    //     let targetMapping = null;
        
    //     // IMPORTANT - search specifically for question "Male ç”² strong" rather than "Who am I?"
    //     // The issue is the API is finding the parent question (1910) instead of the specific question (1911)
    //     for (const mapping of mappingsData) {
    //       // Look for QuestionText that contains gender + symbol + strength
    //       if (mapping.QuestionText && 
    //           mapping.QuestionText.includes(userGender) && 
    //           mapping.QuestionText.includes(symbolToMatch) &&
    //           ((strengthCode === 0 && mapping.QuestionText.includes("strong")) ||
    //           (strengthCode === 1 && mapping.QuestionText.includes("weak")))) {
            
    //         targetMapping = mapping;
    //         // console.log(`Found TEXT match: "${mapping.QuestionText}" with ID ${mapping.QuestionID}`);
    //         break;
    //       }
    //     }
        
    //     // If no text match found, try by exact attribute values
    //     if (!targetMapping) {
    //       for (const mapping of mappingsData) {
    //         if (mapping.Gender === genderCode && 
    //             mapping.Strength === strengthCode && 
    //             mapping.Symbol === symbolToMatch) {
              
    //           targetMapping = mapping;
    //           // console.log(`Found ATTRIBUTE match: "${mapping.QuestionText}" with ID ${mapping.QuestionID}`);
    //           break;
    //         }
    //       }
    //     }
        
    //     // If still no match found, try to find the closest match
    //     if (!targetMapping) {
    //       // console.log("No exact match found, looking for closest match");
          
    //       // First try to match by symbol and gender
    //       for (const mapping of mappingsData) {
    //         if (mapping.Symbol === symbolToMatch && mapping.Gender === genderCode) {
    //           targetMapping = mapping;
    //           // console.log(`Found partial match (symbol+gender): "${mapping.QuestionText}" with ID ${mapping.QuestionID}`);
    //           break;
    //         }
    //       }
          
    //       // If still no match, try just by symbol
    //       if (!targetMapping) {
    //         for (const mapping of mappingsData) {
    //           if (mapping.Symbol === symbolToMatch) {
    //             targetMapping = mapping;
    //             // console.log(`Found symbol-only match: "${mapping.QuestionText}" with ID ${mapping.QuestionID}`);
    //             break;
    //           }
    //         }
    //       }
    //     }
        
    //     // If still no match found, show sorry message
    //     if (!targetMapping) {
    //       // console.log("No match found for all attributes");
          
    //       setMessages((prev) => [
    //         ...prev,
    //         { 
    //           sender: "bot", 
    //           text: `Sorry, I couldn't find a specific character profile matching your gender (${userGender}), natal element (${symbolToMatch}), and chart strength (${chartStrengthData?.category}). Please try a different query.` 
    //         }
    //       ]);
    //       setLoading(false);
    //       setInput("");
    //       return;
    //     }
        
    //     // Important: Use the EXACT QuestionID from the matched mapping
    //     // console.log(`Making identity API call with ID: ${targetMapping.QuestionID}`);
        
    //     const targetResponse = await fetch(
    //       `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=myself&questionid=${targetMapping.QuestionID}`
    //     );
        
    //     const targetData = await targetResponse.json();
    //     // console.log(`Identity API response with ID ${targetMapping.QuestionID}:`, targetData);
        
    //     // Add bot response
    //     setMessages((prev) => [
    //       ...prev,
    //       { sender: "bot", text: targetData.answer || "Here's insight about your character..." }
    //     ]);
        
    //     // Handle follow-up options
    //     if (targetData.selection) {
    //       const cleanedSelection = targetData.selection.replace(/\n/g, '');
    //       const selections = cleanedSelection.split(',').map((s) => {
    //         if (s.includes("|")) {
    //           const [id, text] = s.split("|");
    //           return { id: id.trim(), text: text.trim() };
    //         } else {
    //           return { id: s, text: s.trim() };
    //         }
    //       });
          
    //       setQuestions(selections);
    //       setHideInitialQuestions(false);
    //     } else {
    //       setQuestions([]);
    //       setHideInitialQuestions(true);
    //     }
        
    //     setIsFinal(targetData.isfinal === 1);
    //     setLoading(false);
    //     setInput("");
    //     return;
        
    //   } catch (error) {
    //     // console.error("Error in identity detection:", error);
    //     setMessages((prev) => [
    //       ...prev,
    //       { 
    //         sender: "bot", 
    //         text: "I encountered an error analyzing your character. Please try again later." 
    //       }
    //     ]);
    //     setLoading(false);
    //     setInput("");
    //     return;
    //   }
    // }
      
      // Money luck detection
      // if (normalizedQuery.includes("money luck") || 
      //     normalizedQuery.includes("money") || 
      //     normalizedQuery.includes("wealth luck")) {
      //   try {
      //     // First check user gender
      //     const userGenderData = userGender.toLowerCase();
      //     // Check natal element
      //     const userNatalElement = userZodiac.natal;
      //     // Check chart strength
      //     const isStrongChart = chartStrengthData && chartStrengthData.category === "strong";
          
      //     // console.log(`Character detection - Gender: ${userGenderData}, Natal: ${userNatalElement}, Chart Strength: ${isStrongChart ? "Strong" : "Weak"}`);
          
      //     // Add user's original query to messages
      //     setMessages((prev) => [
      //       ...prev,
      //       { sender: "user", text: userQuery }
      //     ]);
          
      //     let targetId;
          
      //     // First determine based on gender and natal element
      //     if (userNatalElement) {
      //       if (userGenderData === "female") {
      //         // FEMALE with natal element - use IDs from left side (strong)
      //         // or right side (weak) based on chart strength
      //         if (userNatalElement.includes("ä¸™")) {
      //           targetId = isStrongChart ? "1809" : "1810"; // ä¸™ female strong/weak IDs
      //         } else if (userNatalElement.includes("ä¸")) {
      //           targetId = isStrongChart ? "1825" : "1826"; // ä¸ female strong/weak IDs
      //         } else if (userNatalElement.includes("æˆŠ")) {
      //           targetId = isStrongChart ? "1834" : "1835"; // æˆŠ female strong/weak IDs
      //         } else if (userNatalElement.includes("å·±")) {
      //           targetId = isStrongChart ? "1852" : "1853"; // å·± female strong/weak IDs
      //         } else if (userNatalElement.includes("åºš")) {
      //           targetId = isStrongChart ? "1864" : "1863"; // åºš female strong/weak IDs
      //         } else if (userNatalElement.includes("è¾›")) {
      //           targetId = isStrongChart ? "1882" : "1881"; // è¾› female strong/weak IDs
      //         } else if (userNatalElement.includes("å£¬")) {
      //           targetId = isStrongChart ? "1890" : "1891"; // å£¬ female strong/weak IDs
      //         } else if (userNatalElement.includes("ç™¸")) {
      //           targetId = isStrongChart ? "1906" : "1907"; // ç™¸ female strong/weak IDs
      //         } else if (userNatalElement.includes("ç”²")) {
      //           targetId = isStrongChart ? "1772" : "1773"; // ç”² female strong/weak IDs
      //         } else if (userNatalElement.includes("ä¹™")) {
      //           targetId = isStrongChart ? "1796" : "1797"; // ä¹™ female strong/weak IDs
      //         } else {
      //           // Fall back to generic strong/weak IDs for female
      //           targetId = isStrongChart ? "701" : "702";
      //         }
      //       } else {
      //         // MALE with natal element - use IDs from left side (strong)
      //         // or right side (weak) based on chart strength
      //         if (userNatalElement.includes("ä¸™")) {
      //           targetId = isStrongChart ? "719" : "720"; // ä¸™ male strong/weak IDs
      //         } else if (userNatalElement.includes("ä¸")) {
      //           targetId = isStrongChart ? "1816" : "1817"; // ä¸ male strong/weak IDs
      //         } else if (userNatalElement.includes("æˆŠ")) {
      //           targetId = isStrongChart ? "737" : "738"; // æˆŠ male strong/weak IDs
      //         } else if (userNatalElement.includes("å·±")) {
      //           targetId = isStrongChart ? "1843" : "1844"; // å·± male strong/weak IDs
      //         } else if (userNatalElement.includes("åºš")) {
      //           targetId = isStrongChart ? "747" : "746"; // åºš male strong/weak IDs
      //         } else if (userNatalElement.includes("è¾›")) {
      //           targetId = isStrongChart ? "1874" : "1873"; // è¾› male strong/weak IDs
      //         } else if (userNatalElement.includes("å£¬")) {
      //           targetId = isStrongChart ? "730" : "731"; // å£¬ male strong/weak IDs
      //         } else if (userNatalElement.includes("ç™¸")) {
      //           targetId = isStrongChart ? "1897" : "1898"; // ç™¸ male strong/weak IDs
      //         } else if (userNatalElement.includes("ç”²")) {
      //           targetId = isStrongChart ? "1736" : "1737"; // ç”² male strong/weak IDs
      //         } else if (userNatalElement.includes("ä¹™")) {
      //           targetId = isStrongChart ? "1785" : "1786"; // ä¹™ male strong/weak IDs
      //         } else {
      //           // Fall back to generic strong/weak IDs for male
      //           targetId = isStrongChart ? "692" : "693";
      //         }
      //       }
      //     } else if (chartStrengthData && chartStrengthData.category) {
      //       // No natal element, but we have chart strength
      //       targetId = userGenderData === "female" ? 
      //         (isStrongChart ? "701" : "702") : 
      //         (isStrongChart ? "692" : "693");
      //     } else {
      //       // Default if neither natal nor chart strength is available
      //       targetId = userGenderData === "female" ? "701" : "692"; // Default to strong
      //     }
          
      //     // Determine query text based on whether strong or weak
      //     const targetQuery = isStrongChart ? "strong money luck" : "weak money luck";
    
      //     // console.log(`Selected money luck routing: Gender=${userGenderData}, Natal=${userNatalElement}, Strength=${isStrongChart ? "Strong" : "Weak"}, ID=${targetId}`);
          
      //     // Call fetchResponse with the appropriate query and ID

      //     if (targetId) {
      //       const queryParam = `userQuery=${encodeURIComponent("career luck")}`;
      //       const idParam = `&questionid=${targetId}`;
            
      //       const response = await fetch(
      //         `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
      //       );
            
      //       const data = await response.json();
            
      //       // Add bot response
      //       setMessages((prev) => [
      //         ...prev,
      //         { sender: "bot", text: data.answer || "Here's your career luck analysis..." }
      //       ]);
            
      //       // Handle selections if any
      //       if (data.selection) {
      //         const cleanedSelection = data.selection.replace(/\n/g, '');
      //         const selections = cleanedSelection.split(',').map((s) => {
      //           if (s.includes("|")) {
      //             const [id, text] = s.split("|");
      //             return { id: id.trim(), text: text.trim() };
      //           } else {
      //             return { id: s, text: s.trim() };
      //           }
      //         });
              
      //         setQuestions(selections);
      //         setHideInitialQuestions(false);
      //       } else {
      //         setQuestions([]);
      //         setHideInitialQuestions(true);
      //       }
            
      //       setIsFinal(data.isfinal === 1);
      //     }

      //     setLoading(false);
      //     setInput("");
      //     return;
      //   } catch (error) {
      //     // console.error("Error in character detection:", error);
      //     // Fall back to regular API call
      //   }
      // }
      
      // // Career luck detection
      // else if (normalizedQuery.includes("career luck") || 
      //   normalizedQuery.includes("career")) {
      //   try {
      //     // First check user gender
      //     const userGenderData = userGender.toLowerCase();
      //     // Check natal element
      //     const userNatalElement = userZodiac.natal;
      //     // Check chart strength
      //     const isStrongChart = chartStrengthData && chartStrengthData.category === "strong";
          
      //     // console.log(`Character detection - Gender: ${userGenderData}, Natal: ${userNatalElement}, Chart Strength: ${isStrongChart ? "Strong" : "Weak"}`);
          
      //     // Add user's original query to messages
      //     setMessages((prev) => [
      //       ...prev,
      //       { sender: "user", text: userQuery }
      //     ]);
          
      //     let targetId;
          
      //     // First determine based on gender and natal element
      //     if (userNatalElement) {
      //       if (userGenderData === "female") {
      //         // FEMALE with natal element - use IDs from left side (strong)
      //         // or right side (weak) based on chart strength
      //         if (userNatalElement.includes("ä¸™")) {
      //           targetId = isStrongChart ? "1807" : "1808"; // ä¸™ female strong/weak IDs
      //         } else if (userNatalElement.includes("ä¸")) {
      //           targetId = isStrongChart ? "1823" : "1824"; // ä¸ female strong/weak IDs
      //         } else if (userNatalElement.includes("æˆŠ")) {
      //           targetId = isStrongChart ? "1832" : "1833"; // æˆŠ female strong/weak IDs
      //         } else if (userNatalElement.includes("å·±")) {
      //           targetId = isStrongChart ? "1854" : "1855"; // å·± female strong/weak IDs
      //         } else if (userNatalElement.includes("åºš")) {
      //           targetId = isStrongChart ? "1861" : "1862"; // åºš female strong/weak IDs
      //         } else if (userNatalElement.includes("è¾›")) {
      //           targetId = isStrongChart ? "1879" : "1880"; // è¾› female strong/weak IDs
      //         } else if (userNatalElement.includes("å£¬")) {
      //           targetId = isStrongChart ? "1888" : "1889"; // å£¬ female strong/weak IDs
      //         } else if (userNatalElement.includes("ç™¸")) {
      //           targetId = isStrongChart ? "1908" : "1909"; // ç™¸ female strong/weak IDs
      //         } else if (userNatalElement.includes("ç”²")) {
      //           targetId = isStrongChart ? "1774" : "1775"; // ç”² female strong/weak IDs
      //         } else if (userNatalElement.includes("ä¹™")) {
      //           targetId = isStrongChart ? "1798" : "1799"; // ä¹™ female strong/weak IDs
      //         } else {
      //           // Fall back to generic strong/weak IDs for female
      //           targetId = isStrongChart ? "701" : "702";
      //         }
      //       } else {
      //         // MALE with natal element - use IDs from left side (strong)
      //         // or right side (weak) based on chart strength
      //         if (userNatalElement.includes("ä¸™")) {
      //           targetId = isStrongChart ? "717" : "718"; // ä¸™ male strong/weak IDs
      //         } else if (userNatalElement.includes("ä¸")) {
      //           targetId = isStrongChart ? "1818" : "1819"; // ä¸ male strong/weak IDs
      //         } else if (userNatalElement.includes("æˆŠ")) {
      //           targetId = isStrongChart ? "739" : "740"; // æˆŠ male strong/weak IDs
      //         } else if (userNatalElement.includes("å·±")) {
      //           targetId = isStrongChart ? "1845" : "1846"; // å·± male strong/weak IDs
      //         } else if (userNatalElement.includes("åºš")) {
      //           targetId = isStrongChart ? "748" : "749"; // åºš male strong/weak IDs
      //         } else if (userNatalElement.includes("è¾›")) {
      //           targetId = isStrongChart ? "1875" : "1876"; // è¾› male strong/weak IDs
      //         } else if (userNatalElement.includes("å£¬")) {
      //           targetId = isStrongChart ? "728" : "729"; // å£¬ male strong/weak IDs
      //         } else if (userNatalElement.includes("ç™¸")) {
      //           targetId = isStrongChart ? "1899" : "1900"; // ç™¸ male strong/weak IDs
      //         } else if (userNatalElement.includes("ç”²")) {
      //           targetId = isStrongChart ? "1738" : "1739"; // ç”² male strong/weak IDs
      //         } else if (userNatalElement.includes("ä¹™")) {
      //           targetId = isStrongChart ? "1782" : "1781"; // ä¹™ male strong/weak IDs
      //         } else {
      //           // Fall back to generic strong/weak IDs for male
      //           targetId = isStrongChart ? "692" : "693";
      //         }
      //       }
      //     } else if (chartStrengthData && chartStrengthData.category) {
      //       // No natal element, but we have chart strength
      //       targetId = userGenderData === "female" ? 
      //         (isStrongChart ? "701" : "702") : 
      //         (isStrongChart ? "692" : "693");
      //     } else {
      //       // Default if neither natal nor chart strength is available
      //       targetId = userGenderData === "female" ? "701" : "692"; // Default to strong
      //     }
          
      //     // Determine query text based on whether strong or weak
      //     const targetQuery = isStrongChart ? "strong career luck" : "weak career luck";
          
      //     // console.log(`Selected career luck routing: Gender=${userGenderData}, Natal=${userNatalElement}, Strength=${isStrongChart ? "Strong" : "Weak"}, ID=${targetId}`);
          
      //     // Call fetchResponse with the appropriate query and ID
      //     if (targetId) {
      //       const queryParam = `userQuery=${encodeURIComponent("career luck")}`;
      //       const idParam = `&questionid=${targetId}`;
            
      //       const response = await fetch(
      //         `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
      //       );
            
      //       const data = await response.json();
            
      //       // Add bot response
      //       setMessages((prev) => [
      //         ...prev,
      //         { sender: "bot", text: data.answer || "Here's your career luck analysis..." }
      //       ]);
            
      //       // Handle selections if any
      //       if (data.selection) {
      //         const cleanedSelection = data.selection.replace(/\n/g, '');
      //         const selections = cleanedSelection.split(',').map((s) => {
      //           if (s.includes("|")) {
      //             const [id, text] = s.split("|");
      //             return { id: id.trim(), text: text.trim() };
      //           } else {
      //             return { id: s, text: s.trim() };
      //           }
      //         });
              
      //         setQuestions(selections);
      //         setHideInitialQuestions(false);
      //       } else {
      //         setQuestions([]);
      //         setHideInitialQuestions(true);
      //       }
            
      //       setIsFinal(data.isfinal === 1);
      //     }
          
      //     setLoading(false);
      //     setInput("");
      //     return;
      //   } catch (error) {
      //     // console.error("Error in character detection:", error);
      //     // Fall back to regular API call
      //   }
      // }
      
      // // Character detection
      // else if (normalizedQuery.includes("character") || 
      //         normalizedQuery.includes("my character")) {
      //   try {
      //     // Use the gender from state (already properly set in fetchUserData)
      //     const userGenderData = userGender.toLowerCase(); // This is already set from the profile
      //     // Check natal element
      //     const userNatalElement = userZodiac.natal;
      //     // Check chart strength
      //     const isStrongChart = chartStrengthData && chartStrengthData.category === "strong";
          
      //     // console.log(`Character detection - Gender: ${userGenderData}, Natal: ${userNatalElement}, Chart Strength: ${isStrongChart ? "Strong" : "Weak"}`);
          
      //     // Add user's original query to messages
      //     setMessages((prev) => [
      //       ...prev,
      //       { sender: "user", text: userQuery }
      //     ]);
          
      //     let targetId;
          
      //     // First determine based on gender and natal element
      //     if (userNatalElement) {
      //       if (userGenderData === "female") {
      //         // FEMALE with natal element - use IDs from left side (strong)
      //         // or right side (weak) based on chart strength
      //         if (userNatalElement.includes("ä¸™")) {
      //           targetId = isStrongChart ? "1805" : "1806"; // ä¸™ female strong/weak IDs
      //         } else if (userNatalElement.includes("ä¸")) {
      //           targetId = isStrongChart ? "1827" : "1828"; // ä¸ female strong/weak IDs
      //         } else if (userNatalElement.includes("æˆŠ")) {
      //           targetId = isStrongChart ? "1836" : "1837"; // æˆŠ female strong/weak IDs
      //         } else if (userNatalElement.includes("å·±")) {
      //           targetId = isStrongChart ? "1850" : "1851"; // å·± female strong/weak IDs
      //         } else if (userNatalElement.includes("åºš")) {
      //           targetId = isStrongChart ? "1859" : "1860"; // åºš female strong/weak IDs
      //         } else if (userNatalElement.includes("è¾›")) {
      //           targetId = isStrongChart ? "1877" : "1878"; // è¾› female strong/weak IDs
      //         } else if (userNatalElement.includes("å£¬")) {
      //           targetId = isStrongChart ? "1886" : "1887"; // å£¬ female strong/weak IDs
      //         } else if (userNatalElement.includes("ç™¸")) {
      //           targetId = isStrongChart ? "1904" : "1905"; // ç™¸ female strong/weak IDs
      //         } else if (userNatalElement.includes("ç”²")) {
      //           targetId = isStrongChart ? "1770" : "1771"; // ç”² female strong/weak IDs
      //         } else if (userNatalElement.includes("ä¹™")) {
      //           targetId = isStrongChart ? "1794" : "1795"; // ä¹™ female strong/weak IDs
      //         } else {
      //           // Fall back to generic strong/weak IDs for female
      //           targetId = isStrongChart ? "701" : "702";
      //         }
      //       } else {
      //         // MALE with natal element - use IDs from left side (strong)
      //         // or right side (weak) based on chart strength
      //         if (userNatalElement.includes("ä¸™")) {
      //           targetId = isStrongChart ? "721" : "722"; // ä¸™ male strong/weak IDs
      //         } else if (userNatalElement.includes("ä¸")) {
      //           targetId = isStrongChart ? "1814" : "1815"; // ä¸ male strong/weak IDs
      //         } else if (userNatalElement.includes("æˆŠ")) {
      //           targetId = isStrongChart ? "735" : "736"; // æˆŠ male strong/weak IDs
      //         } else if (userNatalElement.includes("å·±")) {
      //           targetId = isStrongChart ? "1841" : "1842"; // å·± male strong/weak IDs
      //         } else if (userNatalElement.includes("åºš")) {
      //           targetId = isStrongChart ? "744" : "745"; // åºš male strong/weak IDs
      //         } else if (userNatalElement.includes("è¾›")) {
      //           targetId = isStrongChart ? "1871" : "1872"; // è¾› male strong/weak IDs
      //         } else if (userNatalElement.includes("å£¬")) {
      //           targetId = isStrongChart ? "726" : "727"; // å£¬ male strong/weak IDs
      //         } else if (userNatalElement.includes("ç™¸")) {
      //           targetId = isStrongChart ? "1895" : "1896"; // ç™¸ male strong/weak IDs
      //         } else if (userNatalElement.includes("ç”²")) {
      //           targetId = isStrongChart ? "1730" : "1731"; // ç”² male strong/weak IDs
      //         } else if (userNatalElement.includes("ä¹™")) {
      //           targetId = isStrongChart ? "1783" : "1784"; // ä¹™ male strong/weak IDs
      //         } else {
      //           // Fall back to generic strong/weak IDs for male
      //           targetId = isStrongChart ? "692" : "693";
      //         }
      //       }
      //     } else if (chartStrengthData && chartStrengthData.category) {
      //       // No natal element, but we have chart strength
      //       targetId = userGenderData === "female" ? 
      //         (isStrongChart ? "701" : "702") : 
      //         (isStrongChart ? "692" : "693");
      //     } else {
      //       // Default if neither natal nor chart strength is available
      //       targetId = userGenderData === "female" ? "701" : "692"; // Default to strong
      //     }
          
      //     // Determine query text based on whether strong or weak
      //     const targetQuery = isStrongChart ? "strong character" : "weak character";
          
      //     // console.log(`Selected character routing: Gender=${userGenderData}, Natal=${userNatalElement}, Strength=${isStrongChart ? "Strong" : "Weak"}, ID=${targetId}`);
          
      //     // Call fetchResponse with the appropriate query and ID
      //     if (targetId) {
      //       const queryParam = `userQuery=${encodeURIComponent("career luck")}`;
      //       const idParam = `&questionid=${targetId}`;
            
      //       const response = await fetch(
      //         `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
      //       );
            
      //       const data = await response.json();
            
      //       // Add bot response
      //       setMessages((prev) => [
      //         ...prev,
      //         { sender: "bot", text: data.answer || "Here's your character analysis..." }
      //       ]);
            
      //       // Handle selections if any
      //       if (data.selection) {
      //         const cleanedSelection = data.selection.replace(/\n/g, '');
      //         const selections = cleanedSelection.split(',').map((s) => {
      //           if (s.includes("|")) {
      //             const [id, text] = s.split("|");
      //             return { id: id.trim(), text: text.trim() };
      //           } else {
      //             return { id: s, text: s.trim() };
      //           }
      //         });
              
      //         setQuestions(selections);
      //         setHideInitialQuestions(false);
      //       } else {
      //         setQuestions([]);
      //         setHideInitialQuestions(true);
      //       }
            
      //       setIsFinal(data.isfinal === 1);
      //     }
          
      //     setLoading(false);
      //     setInput("");
      //     return;
      //   } catch (error) {
      //     // console.error("Error in character detection:", error);
      //     // Fall back to regular API call
      //   }
      // }
    
      // // If no match, try with user's zodiac sign prepended
      // if (!matchedQuestionId && userZodiac.sign) {
      //   // Create zodiac-specific keywords
      //   const zodiacPrefix = userZodiac.sign.toLowerCase();
      //   const zodiacSpecificQuery = `${zodiacPrefix} ${normalizedQuery}`;
        
      //   // Check if this zodiac-specific keyword exists in our mappings
      //   matchedQuestionId = keywordMappings[zodiacSpecificQuery];
        
      //   if (matchedQuestionId) {
      //     // console.log(`Matched query using zodiac context: "${zodiacSpecificQuery}" -> ID ${matchedQuestionId}`);
      //   }
      // }

      // function findBestKeywordMatch(userQuery, keywordMappings, userZodiac) {
      //   const normalizedQuery = userQuery.toLowerCase().trim();
        
      //   // console.log(`Analyzing query: "${normalizedQuery}"`);
        
      //   // Check for exact match first (full query)
      //   if (keywordMappings[normalizedQuery]) {
      //     // console.log(`Exact match found: "${normalizedQuery}" -> ID ${keywordMappings[normalizedQuery]}`);
      //     return keywordMappings[normalizedQuery];
      //   }
        
      //   // Split user query into individual words
      //   const queryWords = normalizedQuery.split(/\s+/);
      //   const queryWordCount = queryWords.length;
        
      //   // Create an array of words in REVERSE order (from end to beginning)
      //   const reversedQueryWords = [...queryWords].reverse();
        
      //   // 1. First try single word matches from END to BEGINNING
      //   for (const word of reversedQueryWords) {
      //     if (word.length > 1 && keywordMappings[word]) { // Only match meaningful words
      //       // console.log(`Found match with word from end: "${word}" -> ID ${keywordMappings[word]}`);
      //       return keywordMappings[word];
      //     }
      //   }
        
      //   // 2. Try analyzing reversed n-grams (phrases from the end)
      //   for (let n = 2; n <= queryWordCount; n++) {
      //     // Take n words from the end
      //     const endPhrase = queryWords.slice(queryWordCount - n).join(' ');
          
      //     if (keywordMappings[endPhrase]) {
      //       // console.log(`End phrase match: "${endPhrase}" -> ID ${keywordMappings[endPhrase]}`);
      //       return keywordMappings[endPhrase];
      //     }
      //   }
        
      //   // 3. Try analyzing n-grams from the beginning (as a fallback)
      //   for (let n = queryWordCount - 1; n >= 1; n--) {
      //     // Generate all possible n-grams from the query (from beginning)
      //     for (let i = 0; i <= queryWordCount - n; i++) {
      //       const ngram = queryWords.slice(i, i + n).join(' ');
            
      //       if (keywordMappings[ngram]) {
      //         // console.log(`N-gram match found: "${ngram}" -> ID ${keywordMappings[ngram]}`);
      //         return keywordMappings[ngram];
      //       }
      //     }
      //   }
        
      //   // 4. Try contextual matching with zodiac information
        // if (userZodiac && userZodiac.sign) {
        //   const zodiacSign = userZodiac.sign.toLowerCase();
          
        //   // Check if any keyword contains both the zodiac sign and a portion of the query
        //   for (const keyword of Object.keys(keywordMappings)) {
        //     const lowerKeyword = keyword.toLowerCase();
            
        //     // If keyword contains the zodiac sign
        //     if (lowerKeyword.includes(zodiacSign)) {
        //       // Remove the zodiac part and check if the rest matches parts of the query
        //       const keywordWithoutZodiac = lowerKeyword.replace(zodiacSign, '').trim();
              
        //       // Check if significant portions of the keyword (without zodiac) appear in the query
        //       const keywordParts = keywordWithoutZodiac.split(/\s+/);
        //       let matchCount = 0;
              
        //       for (const part of keywordParts) {
        //         if (part.length > 2 && normalizedQuery.includes(part)) { // Only consider meaningful words
        //           matchCount++;
        //         }
        //       }
              
        //       // If majority of the keyword parts are in the query
        //       if (keywordParts.length > 0 && matchCount / keywordParts.length >= 0.5) {
        //         // console.log(`Zodiac context match: "${lowerKeyword}" -> ID ${keywordMappings[keyword]}`);
        //         return keywordMappings[keyword];
        //       }
        //     }
        //   }
        // }
        
      //   // 5. If we reach here, no match was found
      //   // console.log("No keyword match found");
      //   return null;
      // }
      
      
      // // If still no match, try partial matching as fallback
      // if (!matchedQuestionId) {
      //   matchedQuestionId = findBestKeywordMatch(normalizedQuery, keywordMappings, userZodiac);
      // }
      
      
      // If we found a mapping, use it as our questionId
      // if (matchedQuestionId) {
      //   // console.log(`Using keyword mapping: ${matchedQuestionId} for query: ${userQuery}`);
      //   questionId = matchedQuestionId;
      // }
    }

    if (questionId) {
      try {
        if ((questionId === 1 || questionId === 2 || questionId === 3 || questionId === 4) && 
            (userQuery.toLowerCase().includes("find out more about myself male") || 
            userQuery.toLowerCase().includes("find out more about myself female") || 
            userQuery.toLowerCase().includes("natal zodiac pillar readings") || 
            userQuery.toLowerCase().includes("find out about my natal"))) {
          // console.log(`Resetting questionId from ${questionId} to null for query: ${userQuery}`);
          questionId = null;  // Use null to omit the questionId parameter
        }
        // Use the question ID from button click or keyword mapping
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = `&questionid=${questionId}`;
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        // console.log(`API response for query "${userQuery}" with ID ${questionId}:`, data);
        
        // Process the response as usual
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer }
        ]);
        
        // Handle selections
        if (data.selection) {
          const cleanedSelection = data.selection.replace(/\n/g, '');
          const selections = cleanedSelection.split(',')
            .filter(s => s.trim()) // Filter out empty entries
            .map((s) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id: id.trim(), text: text.trim() };
              } else {
                return { id: s, text: s.trim() };
              }
            });

          // console.log("Processing selection with length:", selections.length);
          // console.log("API returned selections:", data.selection.replace(/\n/g, '').split(',').filter(s => s.trim()).length);
          // console.log("Setting questions:", selections.length > 0 ? "YES" : "NO");
          // console.log("Hiding buttons:", hideInitialQuestions);

          // Clear questions first and ensure buttons are hidden
          setHideInitialQuestions(true);
          setQuestions([]);
          

          // Then use a single setTimeout with enough delay
          setTimeout(() => {
            // Set new questions
            setQuestions(selections);
            
            // Only if we have questions to show, set hideInitialQuestions to false
            if (selections && selections.length > 0) {
              // console.log("Setting buttons visible for", selections.length, "selections");
              setHideInitialQuestions(false);
            }
          }, 100);
        }
        
        setIsFinal(data.isfinal === 1);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error(`Error processing query with ID ${questionId}:`, error);
        setLoading(false);
        setInput("");
        return;
      }
    }
    

    /*
    if (userQuery.toLowerCase().includes("yearly zodiac") ||
        userQuery.toLowerCase() === "yearly zodiac") {
      // console.log("Yearly zodiac detected - treating as zodiac query");
      // Use the same logic as the zodiac/zodiac 2025 case
      setHideInitialQuestions(false);
      setHideCategoryButtons(false);
      setIsFinal(false);
      await fetchZodiacData();
      setLoading(false);
      setInput("");
      return;
    }

    // Add this special case for pillar readings before your other checks
    if (questionId === "643") {
      // This is the parent question ID for "Natal zodiac pillar readings"
      // console.log("ðŸ”¶ Pillar readings parent - handling zodiac selection");
      
      try {
        // IMPORTANT FIX: We should NOT use questionId 643 again for the zodiac selection
        // Instead, we should make a clean request with just the userQuery
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${encodeURIComponent(userQuery)}`
        );
        
        const data = await response.json();
        // console.log("ðŸ”¶ Pillar zodiac selection response:", data);
        
        // Add user's message and bot response
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || `Information about ${userQuery}` }
        ]);
        
        // Process the selection specially
        if (data.selection) {
          const selections = data.selection.replace(/\n/g, '').split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log("ðŸ”¶ Pillar selections:", selections);
          setQuestions(selections);
          setHideInitialQuestions(false);
        } else {
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error(`Error processing pillar zodiac selection for ${userQuery}:`, error);
        setLoading(false);
        setInput("");
        return;
      }
    }
      */

    // if (userQuery.toLowerCase().includes("natal") || userQuery.toLowerCase().includes("my natal") || userQuery.toLowerCase().includes("what is my natal")) {
    //   try {
    //     // Use the specific question ID for natal elements (709)
    //     const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
    //     const response = await fetch(
    //       `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
    //     );

    //     const data = await response.json();
    //     // console.log("Natal query response:", data);

    //     // Display the bot's response with the proper message from the API
    //     setMessages((prev) => [
    //       ...prev,
    //       { sender: "user", text: userQuery },
    //       { sender: "bot", text: data.answer || "What is your natal symbol" }
    //     ]);

    //     // IMPORTANT: Completely reset UI state first
    //     setHideInitialQuestions(true);
    //     setAllCharts([]);
    //     setShowChart(false);

    //     // Process the selection options from API directly
    //     if (data.selection) {
    //       const cleanedSelection = data.selection.replace(/\n/g, '');
    //       const natalElements = cleanedSelection.split(',').map((s) => {
    //         if (s.includes("|")) {
    //           const [id, text] = s.split("|");
    //           return { id: id.trim(), text: text.trim() };
    //         } else {
    //           return { id: s, text: s.trim() };
    //         }
    //       });
          
    //       // console.log("Natal selections:", natalElements);
          
    //       // Set questions directly and force hideInitialQuestions to false
    //       setQuestions(natalElements);
          
    //       // Force this to false to ensure buttons appear
    //       setTimeout(() => {
    //         setHideInitialQuestions(false);
    //         // console.log("Forced hideInitialQuestions to false");
    //       }, 200);
    //     }
        
    //     setIsFinal(false);
    //     setLoading(false);
    //     setInput("");
    //     return;
    //   } catch (error) {
    //     // console.error("Error processing natal query:", error);
    //     setLoading(false);
    //     setInput("");
    //     return;
    //   }
    // }

    // // Check if this is a zodiac keyword query
    // const zodiacKeywords = [
    //   "zodiac rat", "zodiac ox", "zodiac tiger", "zodiac rabbit", 
    //   "zodiac dragon", "zodiac snake", "zodiac horse", "zodiac goat", 
    //   "zodiac monkey", "zodiac rooster", "zodiac dog", "zodiac pig", 
    //   "rat zodiac", "ox zodiac", "tiger zodiac", "rabbit zodiac", 
    //   "dragon zodiac", "snake zodiac", "horse zodiac", "goat zodiac", 
    //   "monkey zodiac", "rooster zodiac", "dog zodiac", "pig zodiac", 
    //   "rat", "ox", "tiger", "rabbit", 
    //   "dragon", "snake", "horse", "goat", 
    //   "monkey", "rooster", "dog", "pig"
    // ];
    
    // // Check if the query contains any zodiac animal keyword
    // for (const keyword of zodiacKeywords) {
    //   if (userQuery.toLowerCase().includes(keyword)) {
    //     // Extract the zodiac animal name
    //     const zodiacSign = keyword.replace("zodiac ", "");
    //     await handleZodiacKeywordQuery(zodiacSign);
    //     setInput("");
    //     return;
    //   }
    // }

    /*
    if (userQuery.toLowerCase() === "strong" || 
        userQuery.toLowerCase() === "strong pillar" ||
        userQuery.toLowerCase() === "weak" ||
        userQuery.toLowerCase() === "weak pillar") {
      try {
        // First make sure we have the user's zodiac sign
        let zodiacSign = userZodiac.sign;
        
        if (!zodiacSign) {
          // If we don't have it yet, fetch zodiac data first
          const birthDate = new Date(apiDate);
          const year = birthDate.getFullYear();
          const month = (birthDate.getMonth() + 1).toString().padStart(2, "0");
          const day = birthDate.getDate().toString().padStart(2, "0");
          const hour = birthDate.getHours();
          const minutes = birthDate.getMinutes();

          // Format time as HH:MM
          const timeString = `${hour.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;

          // Get zodiac data
          const zodiacResponse = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
          );
          
          const zodiacData = await zodiacResponse.json();
          
          if (zodiacData && zodiacData.length > 0) {
            zodiacSign = zodiacData[0].ZODIAC;
            // Update state with the zodiac information
            setUserZodiac({
              sign: zodiacSign,
              chineseSign: zodiacData[0].ZODIAC_CN || "",
              natal: zodiacData[0].NATAL || ""
            });
          }
        }
        
        // First, call the API to get the zodiac list with IDs (655-666)
        const zodiacListQueryParam = `userQuery=pillar`;
        const zodiacListResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${zodiacListQueryParam}`
        );

        const zodiacListData = await zodiacListResponse.json();
        // console.log("Pillar zodiac list response:", zodiacListData);
        
        // Find the matching ID for user's zodiac sign
        let userZodiacId = null;
        
        if (zodiacListData.selection) {
          const selections = zodiacListData.selection.replace(/\n/g, '').split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // Find the user's zodiac in the selection list
          const userZodiacItem = selections.find(item => 
            item.text.toLowerCase().includes(zodiacSign.toLowerCase())
          );
          
          if (userZodiacItem) {
            userZodiacId = userZodiacItem.id;
            // console.log(`Found user's zodiac ${zodiacSign} with ID ${userZodiacId}`);
          }
        }
        
        // Now that we have the zodiac ID, make another call to get the strong/weak pillar options
        if (userZodiacId) {
          // Call API with the user's zodiac ID to get pillar options first
          const pillarOptionsResponse = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=pillar&questionid=${userZodiacId}`
          );
          
          const pillarOptionsData = await pillarOptionsResponse.json();
          // console.log(`Pillar options for ${zodiacSign} with ID ${userZodiacId}:`, pillarOptionsData);
          
          // Parse and find strong/weak pillar buttons
          let strongPillarId = null;
          let weakPillarId = null;
          
          if (pillarOptionsData.selection) {
            const pillars = pillarOptionsData.selection.replace(/\n/g, '').split(',').map((s) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id: id.trim(), text: text.trim() };
              } else {
                return { id: s, text: s.trim() };
              }
            });
            
            // Find the strong and weak pillar IDs
            for (const pillar of pillars) {
              if (pillar.text.toLowerCase().includes("strong")) {
                strongPillarId = pillar.id;
              } else if (pillar.text.toLowerCase().includes("weak")) {
                weakPillarId = pillar.id;
              }
            }
          }
          
          // Now make the specific query based on whether user asked for strong or weak
          let pillarQueryId = null;
          let pillarType = "";
          
          if (userQuery.toLowerCase().includes("strong")) {
            pillarQueryId = strongPillarId;
            pillarType = "Strong";
          } else {
            pillarQueryId = weakPillarId;
            pillarType = "Weak";
          }
          
          if (pillarQueryId) {
            // Make the final API call to get the specific pillar information
            const pillarResponse = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${pillarType} Pillar&questionid=${pillarQueryId}`
            );
            
            const pillarData = await pillarResponse.json();
            // console.log(`${pillarType} pillar data response:`, pillarData);
            
            // Add user message and bot response
            setMessages((prev) => [
              ...prev,
              { sender: "user", text: userQuery },
              { 
                sender: "bot", 
                text: pillarData.answer || `As a ${zodiacSign}, your ${pillarType.toLowerCase()} pillar is...` 
              }
            ]);
            
            // Handle any follow-up buttons from the API
            if (pillarData.selection) {
              const selections = pillarData.selection.replace(/\n/g, '').split(',').map((s) => {
                if (s.includes("|")) {
                  const [id, text] = s.split("|");
                  return { id: id.trim(), text: text.trim() };
                } else {
                  return { id: s, text: s.trim() };
                }
              });
              
              setQuestions(selections);
              setHideInitialQuestions(false);
            } else {
              setQuestions([]);
              setHideInitialQuestions(true);
            }
          } else {
            // If we couldn't find the right pillar ID
            setMessages((prev) => [
              ...prev,
              { sender: "user", text: userQuery },
              { 
                sender: "bot", 
                text: `I couldn't retrieve the ${pillarType.toLowerCase()} pillar information for your ${zodiacSign} sign.` 
              }
            ]);
          }
        } else {
          // If we couldn't match the user's zodiac
          setMessages((prev) => [
            ...prev,
            { sender: "user", text: userQuery },
            { 
              sender: "bot", 
              text: "I couldn't identify your zodiac sign to provide pillar information. Please try asking about 'pillars' first." 
            }
          ]);
        }
        
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error("Error processing direct pillar query:", error);
        // Error handling
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: "Sorry, I couldn't retrieve your pillar information at this moment." }
        ]);
        setLoading(false);
        setInput("");
        return;
      }
    }

    if (userQuery.toLowerCase() === "money luck" || userQuery.toLowerCase() === "career luck") {
      try {
        // Determine which type of luck the user is asking about
        const isMoneyLuck = userQuery.toLowerCase().includes("money");
        
        // Use the specific question IDs for each type
        const questionId = isMoneyLuck ? "694" : "697";
        
        // Make the API call with the correct question ID
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = `&questionid=${questionId}`;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
    
        const data = await response.json();
        // console.log(`${userQuery} API response with ID ${questionId}:`, data);
    
        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || `Here's information about your ${isMoneyLuck ? "money" : "career"} luck.` }
        ]);
    
        // Reset button display
        setHideInitialQuestions(true);
        
        // Set hardcoded buttons based on type
        if (isMoneyLuck) {
          setQuestions([
            { id: "695", text: "Strong Money Luck" },
            { id: "696", text: "Weak Money Luck" }
          ]);
        } else {
          setQuestions([
            { id: "698", text: "Strong Career Luck" },
            { id: "699", text: "Weak Career Luck" }
          ]);
        }
        
        // Show the buttons
        setTimeout(() => {
          setHideInitialQuestions(false);
        }, 100);
        
        setIsFinal(false);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error(`Error processing ${userQuery} query:`, error);
        // Error handling
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: `Sorry, I couldn't retrieve information about your ${userQuery} at this moment.` }
        ]);
        setLoading(false);
        setInput("");
        return;
      }
    }

    if (userQuery.toLowerCase() === "strong money luck" || 
        userQuery.toLowerCase() === "weak money luck" ||
        userQuery.toLowerCase() === "strong career luck" || 
        userQuery.toLowerCase() === "weak career luck") {
      try {
        // Determine which type and strength for the correct question ID
        const isMoneyLuck = userQuery.toLowerCase().includes("money");
        const isStrong = userQuery.toLowerCase().includes("strong");
        
        // Map to the specific question IDs for each type
        let questionId;
        if (isMoneyLuck) {
          questionId = isStrong ? "695" : "696";  // Strong or Weak Money Luck
        } else {
          questionId = isStrong ? "698" : "699";  // Strong or Weak Career Luck
        }
        
        // Make the API call with the specific question ID
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = `&questionid=${questionId}`;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );

        const data = await response.json();
        // console.log(`${userQuery} API response with ID ${questionId}:`, data);

        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || `Here's information about your ${isStrong ? "strong" : "weak"} ${isMoneyLuck ? "money" : "career"} luck.` }
        ]);

        // Hide all buttons by default - this is crucial
        setHideInitialQuestions(true);
        setQuestions([]);
        
        // Only show follow-up buttons if the API provides them
        if (data.selection) {
          const selections = data.selection.replace(/\n/g, '').split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          setQuestions(selections);
          setHideInitialQuestions(false);
        }
        
        setIsFinal(data.isfinal === 1);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error(`Error processing ${userQuery} query:`, error);
        // Error handling
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: `Sorry, I couldn't retrieve information about your ${userQuery} at this moment.` }
        ]);
        setLoading(false);
        setInput("");
        return;
      }
    }

    */


    
    if (questionId !== null) {
      try {
        // This is a selection from an API response with a proper questionId
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = `&questionid=${questionId}`;
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        // console.log(`Selection API response for ${userQuery}:`, data);
        
        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || `Information about ${userQuery}` }
        ]);
        
        // Handle any follow-up selections
        if (data.selection) {
          const cleanedSelection = data.selection.replace(/\n/g, '');
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          setQuestions(selections);
          setHideInitialQuestions(false);
        } else {
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error(`Error processing API selection ${userQuery}:`, error);
        setLoading(false);
        setInput("");
        return;
      }
    }
    /*
    if (userQuery.toLowerCase() === "what is my character?" || 
        userQuery.toLowerCase() === "what is my character" || 
        userQuery.toLowerCase() === "character") {
      try {
        // Make the API call WITH the specific question ID 691
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}&questionid=691`
        );

        const data = await response.json();
        // console.log("Character API response with ID 691:", data);

        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || "Here's information about your character." }
        ]);

        // Reset button display
        setHideInitialQuestions(true);
        
        // Always use the hardcoded options regardless of API response
        const characterOptions = [
          { id: "692", text: "Strong Character" },
          { id: "693", text: "Weak Character" }
        ];
        
        setQuestions(characterOptions);
        
        // Show the buttons
        setTimeout(() => {
          setHideInitialQuestions(false);
        }, 100);
        
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error("Error processing character query:", error);
        setLoading(false);
        setInput("");
        return;
      }
    }

    if (userQuery.toLowerCase() === "natal" || 
        userQuery.toLowerCase().includes("find out about my natal") ||
        userQuery.toLowerCase().includes("find out my natal") ||
        userQuery.toLowerCase().includes("what is my natal")) {
      try {
        // Use the specific question ID for natal elements
        const queryParam = `userQuery=natal`;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
        );

        const data = await response.json();
        // console.log("Natal query response:", data);
        // console.log("Has selections?", !!data.selection);

        // Display the bot's response with the proper message from the API
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer }
        ]);

        // Reset other UI elements
        setHideInitialQuestions(true);
        // console.log("hideInitialQuestions set to true");
        
        setAllCharts([]); // Clear all charts
        setShowChart(false); // Hide chart display

        // Use the selection options directly from the API
        if (data.selection) {
          const cleanedSelection = data.selection.replace(/\n/g, '');
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log("Natal selections from API:", selections);
          setQuestions(selections);
          
          // console.log("Setting questions to:", selections);
          // console.log("About to set hideInitialQuestions to false");
          
          // First, set the questions
          setQuestions(selections);
          
          // Then, use setTimeout to ensure state updates properly
          setTimeout(() => {
            setHideInitialQuestions(false);
            // console.log("hideInitialQuestions set to false after setTimeout");
          }, 300);  // Increased to 300ms
        } else {
          // Fallback to hardcoded buttons if API doesn't return them
          // console.log("API didn't return selections, using hardcoded options");
          const natalElementOptions = [
            { id: "710", text: "ä¸™ & ä¸" },
            { id: "711", text: "æˆŠ & å·±" },
            { id: "712", text: "åºš & è¾›" },
            { id: "713", text: "å£¬ & ç™¸" }
          ];
          
          setQuestions(natalElementOptions);
          // console.log("Setting questions to hardcoded options:", natalElementOptions);
          
          setTimeout(() => {
            setHideInitialQuestions(false);
            // console.log("hideInitialQuestions set to false for hardcoded options");
          }, 200);
        }
        
        setIsFinal(false);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error("Error processing natal query:", error);
        setLoading(false);
        setInput("");
        return;
      }
    }

  if (userQuery.toLowerCase().includes("natal zodiac") || 
      userQuery.toLowerCase().includes("natal zodiac reading") || 
      userQuery.toLowerCase() === "pillar" || 
      userQuery.toLowerCase() === "pillars") {
    try {
      // First make sure we have the user's zodiac sign
      let zodiacSign = userZodiac.sign;
      
      if (!zodiacSign) {
        // If we don't have it yet, fetch zodiac data first
        const birthDate = new Date(apiDate);
        const year = birthDate.getFullYear();
        const month = (birthDate.getMonth() + 1).toString().padStart(2, "0");
        const day = birthDate.getDate().toString().padStart(2, "0");
        const hour = birthDate.getHours();
        const minutes = birthDate.getMinutes();

        // Format time as HH:MM
        const timeString = `${hour.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;

        // Get zodiac data
        const zodiacResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
        );
        
        const zodiacData = await zodiacResponse.json();
        
        if (zodiacData && zodiacData.length > 0) {
          zodiacSign = zodiacData[0].ZODIAC;
          // Update state with the zodiac information
          setUserZodiac({
            sign: zodiacSign,
            chineseSign: zodiacData[0].ZODIAC_CN || "",
            natal: zodiacData[0].NATAL || ""
          });
        }
      }
      
      // First, call the API to get the zodiac list with IDs (655-666)
      const zodiacListQueryParam = `userQuery=pillar`;
      const zodiacListResponse = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${zodiacListQueryParam}`
      );

      const zodiacListData = await zodiacListResponse.json();
      // console.log("Pillar zodiac list response:", zodiacListData);
      
      // Find the matching ID for user's zodiac sign
      let userZodiacId = null;
      
      if (zodiacListData.selection) {
        const selections = zodiacListData.selection.replace(/\n/g, '').split(',').map((s) => {
          if (s.includes("|")) {
            const [id, text] = s.split("|");
            return { id: id.trim(), text: text.trim() };
          } else {
            return { id: s, text: s.trim() };
          }
        });
        
        // Find the user's zodiac in the selection list
        const userZodiacItem = selections.find(item => 
          item.text.toLowerCase().includes(zodiacSign.toLowerCase())
        );
        
        if (userZodiacItem) {
          userZodiacId = userZodiacItem.id;
          // console.log(`Found user's zodiac ${zodiacSign} with ID ${userZodiacId}`);
        }
      }
      
      // Now that we have the zodiac ID, make another call to get the strong/weak pillar options
      if (userZodiacId) {
        // Display a message first
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: `Getting pillar information for your zodiac sign: ${zodiacSign}` }
        ]);
        
        // Call API with the user's zodiac ID
        const pillarOptionsResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=pillar&questionid=${userZodiacId}`
        );
        
        const pillarOptionsData = await pillarOptionsResponse.json();
        // console.log(`Pillar options for ${zodiacSign} with ID ${userZodiacId}:`, pillarOptionsData);
        
        // Update the message with the actual response
        setMessages((prev) => [
          ...prev.slice(0, -1), // Remove the loading message
          { 
            sender: "bot", 
            text: pillarOptionsData.answer || `As a ${zodiacSign}, here are your pillar strengths and weaknesses:` 
          }
        ]);
        
        // Parse and display the strong/weak pillar buttons
        if (pillarOptionsData.selection) {
          const pillars = pillarOptionsData.selection.replace(/\n/g, '').split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log(`Strong/Weak pillar buttons for ${zodiacSign}:`, pillars);
          setQuestions(pillars);
          setHideInitialQuestions(false);
        } else {
          // If no pillar selection options returned, show a message
          setMessages(prev => [
            ...prev,
            { 
              sender: "bot", 
              text: "I couldn't find specific strong/weak pillar information for your zodiac sign." 
            }
          ]);
          setQuestions([]);
          setHideInitialQuestions(true);
        }
      } else {
        // If we couldn't match the user's zodiac, just show the main response
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { 
            sender: "bot", 
            text: zodiacListData.answer || `Here's general information about pillars. Please specify your zodiac sign.` 
          }
        ]);
        
        // Show the zodiac list as buttons
        if (zodiacListData.selection) {
          const zodiacButtons = zodiacListData.selection.replace(/\n/g, '').split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          setQuestions(zodiacButtons);
          setHideInitialQuestions(false);
        }
      }
      
      // Reset other UI elements
      setAllCharts([]); // Clear all charts
      setShowChart(false); // Hide chart display
      setIsFinal(false);
      setLoading(false);
      setInput("");
      return;
    } catch (error) {
      // console.error("Error processing pillar query:", error);
      // Error handling
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { sender: "bot", text: "Sorry, I couldn't retrieve information about your pillars at this moment." }
      ]);
      setLoading(false);
      setInput("");
      return;
    }
  }
  
  if (userQuery.toLowerCase().includes("business") || 
      userQuery.toLowerCase().includes("partner")) {
    try {
      // Get the user's zodiac sign from state
      const userSign = userZodiac.sign;
      
      if (!userSign) {
        // If zodiac isn't set yet, fetch it first
        await fetchZodiacData();
      }
      
      // First, get the parent question ID by sending a query with just the zodiac sign
      const parentQueryParam = `userQuery=${encodeURIComponent(userZodiac.sign)}`;
      const parentResponse = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${parentQueryParam}`
      );
      
      const parentData = await parentResponse.json();
      // console.log("Parent question response for business:", parentData);
      
      // Find the business partner question ID from the selections
      let businessQuestionId = null;
      if (parentData.selection) {
        const selections = parentData.selection.split(",");
        for (const selection of selections) {
          if (selection.includes("ideal business partner")) {
            const [id, text] = selection.split("|");
            businessQuestionId = id.trim();
            break;
          }
        }
      }
      
      // Now make the call with the right parent question ID
      let businessResponse;
      if (businessQuestionId) {
        // Use the proper question ID structure
        businessResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=ideal business partner&questionid=${businessQuestionId}`
        );
      } else {
        // Fallback to the old method
        const enhancedQuery = `${userZodiac.sign} ideal business partner`;
        const queryParam = `userQuery=${encodeURIComponent(enhancedQuery)}`;
        businessResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
        );
      }
      
      const data = await businessResponse.json();
      // console.log("Business partner compatibility response:", data);

      // Enhance the response to make it more personalized
      let enhancedAnswer;
      if (data.answer) {
        enhancedAnswer = `As a ${userZodiac.sign}, your ideal business partners are: ${data.answer}`;
      } else {
        enhancedAnswer = `Based on Chinese zodiac compatibility, as a ${userZodiac.sign}, you should consider certain zodiac signs for business partnerships.`;
      }
      
      // Show the original query and the enhanced response
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { sender: "bot", text: enhancedAnswer },
      ]);
      
      setIsFinal(data.isfinal === 1);
      
      // Handle any follow-up questions
      if (data.selection) {
        const selections = data.selection.split(",").map((s, index) => {
          if (s.includes("|")) {
            const [id, text] = s.split("|");
            return { id, text: text.trim() };
          } else {
            return { id: index, text: s.trim() };
          }
        });
        setQuestions(selections);
        setHideInitialQuestions(false);
      } else {
        setQuestions([]);
        setHideInitialQuestions(true);
      }
      
      setLoading(false);
      setInput("");
      return;
    } catch (error) {
      // console.error("Error processing business partner query:", error);
      // Show a fallback response
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { 
          sender: "bot", 
          text: `Based on Chinese zodiac compatibility, as a ${userZodiac.sign}, look for business partners with complementary skills and compatible energy.` 
        },
      ]);
      setLoading(false);
      setInput("");
      return;
    }
  }

  if (userQuery.toLowerCase().includes("clash") || 
      userQuery.toLowerCase().includes("clashing")) {
    try {
      // Get the user's zodiac sign from state
      const userSign = userZodiac.sign;
      
      if (!userSign) {
        // If zodiac isn't set yet, fetch it first
        await fetchZodiacData();
      }
      
      // First, get the parent question ID by sending a query with just the zodiac sign
      const parentQueryParam = `userQuery=${encodeURIComponent(userZodiac.sign)}`;
      const parentResponse = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${parentQueryParam}`
      );
      
      const parentData = await parentResponse.json();
      // console.log("Parent question response for clash:", parentData);
      
      // Find the clash question ID from the selections
      let clashQuestionId = null;
      if (parentData.selection) {
        const selections = parentData.selection.split(",");
        for (const selection of selections) {
          if (selection.includes("clash with me")) {
            const [id, text] = selection.split("|");
            clashQuestionId = id.trim();
            break;
          }
        }
      }
      
      // Now make the call with the right parent question ID
      let clashResponse;
      if (clashQuestionId) {
        // Use the proper question ID structure
        clashResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=Which zodiac sign clash with me&questionid=${clashQuestionId}`
        );
      } else {
        // Fallback to the old method
        const enhancedQuery = `${userZodiac.sign} Which zodiac sign clash with me`;
        const queryParam = `userQuery=${encodeURIComponent(enhancedQuery)}`;
        clashResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
        );
      }
      
      const data = await clashResponse.json();
      // console.log("Zodiac clash response:", data);

      // Enhance the response to make it more personalized
      let enhancedAnswer;
      if (data.answer) {
        enhancedAnswer = `As a ${userZodiac.sign}, you may experience clashes with: ${data.answer}`;
      } else {
        enhancedAnswer = `Based on Chinese zodiac compatibility, as a ${userZodiac.sign}, you should be cautious with certain zodiac signs that may clash with your energy.`;
      }
      
      // Show the original query and the enhanced response
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { sender: "bot", text: enhancedAnswer },
      ]);
      
      setIsFinal(data.isfinal === 1);
      
      // Handle any follow-up questions
      if (data.selection) {
        const selections = data.selection.split(",").map((s, index) => {
          if (s.includes("|")) {
            const [id, text] = s.split("|");
            return { id, text: text.trim() };
          } else {
            return { id: index, text: s.trim() };
          }
        });
        setQuestions(selections);
        setHideInitialQuestions(false);
      } else {
        setQuestions([]);
        setHideInitialQuestions(true);
      }
      
      setLoading(false);
      setInput("");
      return;
    } catch (error) {
      // console.error("Error processing clash query:", error);
      // Show a fallback response
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { 
          sender: "bot", 
          text: `Based on Chinese zodiac compatibility, as a ${userZodiac.sign}, you should be cautious with zodiac signs that clash with your energy.` 
        },
      ]);
      setLoading(false);
      setInput("");
      return;
    }
  }

    // Check if this is an improvement request
    // Always set showRestartButton to false initially except for improvement requests
    if (
      !userQuery.toLowerCase().includes("improve") &&
      !userQuery.toLowerCase().includes("tell me how")
    ) {
      setShowRestartButton(false);
    }

    // Check if this is an improvement request
    if (
      userQuery.toLowerCase().includes("improve my") ||
      userQuery.toLowerCase().includes("tell me how to improve")
    ) {
      // Set the restart button state here
      setShowRestartButton(true);

      try {
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";

        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );

        const data = await response.json();

        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          {
            sender: "bot",
            text: data.answer || "Here are some tips to improve...",
          },
        ]);

        // Ensure restart button shows after response is received
        setShowRestartButton(true);
        setShowHelpButton(false);
      } catch (error) {
        // console.error("Error fetching improvement response:", error);
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          {
            sender: "bot",
            text: "Sorry, I couldn't retrieve improvement suggestions at this time.",
          },
        ]);

        // Still show restart button even if there's an error
        setShowRestartButton(true);
      }

      setLoading(false);
      setInput("");
      return;
    }
      */

    // IMPORTANT: Reset the chart display whenever a new query is made
    // unless it's specifically a category selection
    if (!Object.keys(categoryMap).includes(userQuery.toLowerCase())) {
      setShowChart(false);
      setChartData(null);
    }

    /*if (userQuery.toLowerCase() === "natal reading") {
      // Ensure the user message appears consistently
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: "Natal reading" },
      ]);

      setShowChart(false);
      setChartData(null);
      setAllCharts([]);
      setHideInitialQuestions(false);
      setHideCategoryButtons(false);

      await fetchNatalData();
      setLoading(false);
      setInput("");
      return;
    }

    // Check if this is a zodiac topic button
    const zodiacTopics = [
      "Education",
      "General",
      "Wealth",
      "Career",
      "Love & Relationship",
      "Health",
    ];
    if (zodiacTopics.includes(userQuery)) {
      handleZodiacTopicSelection(userQuery);
      setLoading(false);
      setInput("");
      return;
    }

    if (
      userQuery.toLowerCase() === "zodiac" ||
      userQuery.toLowerCase() === "zodiac 2025" ||
      userQuery.toLowerCase() === "yearly zodiac" 
       //|| userQuery.toLowerCase() === "This year zodiac reading" 
    ) {
      // Add user message to the conversation

      // Important: Set these states to ensure buttons appear
      setHideInitialQuestions(false);
      setHideCategoryButtons(false);
      setIsFinal(false);

      // Call the same function as when "Zodiac 2025" button is clicked
      await fetchZodiacData();
      setLoading(false);
      setInput("");
      return;
    }
    
    if (userQuery === "Natal reading") {
      // Make sure charts are cleared before showing natal reading options
      setShowChart(false);
      setChartData(null);
      await fetchNatalData();
      setLoading(false);
      setInput("");
      return;
    } 

      if (userQuery.toLowerCase().includes("this year zodiac reading") ||
        userQuery.toLowerCase() === "this year zodiac reading") {
      try {
        // Make the API call using the exact user query
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
        );

        const data = await response.json();
        // console.log("This year zodiac reading response:", data);

        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || "Select your zodiac sign" }
        ]);

        // Fix: Hide all other buttons first
        setHideInitialQuestions(true);
        setAllCharts([]); // Clear all charts
        
        setShowChart(false); // Hide chart display

        // Handle the selection options from API
        if (data.selection) {
          // Need to clean up the selection string since it contains newlines
          const cleanedSelection = data.selection.replace(/\n/g, '');
          
          // Parse the selection options 
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log("Parsed selections:", selections);
          
          // Set the buttons
          setQuestions(selections);
          
          // Important: Use a setTimeout to ensure state updates properly
          setTimeout(() => {
            setHideInitialQuestions(false); // Now show these buttons
          }, 100);
          
          // Hide the "Sorry" message buttons
          setMessages((prev) => prev.map(msg => {
            if (msg.sender === "bot" && 
                msg.text && 
                msg.text.includes("Sorry, but we didn't find what your looking for")) {
              return { ...msg, text: msg.text.replace("Sorry, but we didn't find what", "I couldn't find what") };
            }
            return msg;
          }));
        } else {
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);

        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error("Error processing this year zodiac reading request:", error);
        // Error handling
        setLoading(false);
        setInput("");
        return;
      }
    }

    if (userQuery.toLowerCase().includes("find out more about myself") || 
        userQuery.toLowerCase().includes("natal day female") ||
        userQuery.toLowerCase().includes("natal day male")) {
      try {
        // Make the API call using the exact user query
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
        );

        const data = await response.json();
        // console.log("Find out more/Natal Day response:", data);

        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || "What is your natal" }
        ]);

        // Fix: Hide all other buttons first
        setHideInitialQuestions(true);
        setAllCharts([]); // Clear all charts
        
        setShowChart(false); // Hide chart display

        // Handle the selection options from API
        if (data.selection) {
          // Need to clean up the selection string since it contains newlines
          const cleanedSelection = data.selection.replace(/\n/g, '');
          
          // Parse the selection options 
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log("Parsed selections:", selections);
          
          // Set the buttons
          setQuestions(selections);
          
          // Important: Use a setTimeout to ensure state updates properly
          setTimeout(() => {
            setHideInitialQuestions(false); // Now show these buttons
          }, 100);
          
          // Hide the "Sorry" message buttons
          setMessages((prev) => prev.map(msg => {
            if (msg.sender === "bot" && 
                msg.text && 
                msg.text.includes("Sorry, but we didn't find what your looking for")) {
              return { ...msg, text: msg.text.replace("Sorry, but we didn't find what", "I couldn't find what") };
            }
            return msg;
          }));
        } else {
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);

        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error("Error processing natal day/find out more request:", error);
        // Error handling...
        setLoading(false);
        setInput("");
        return;
      }
    }

    if (userQuery === "What is my character?") {
      try {
        // Make the API call with the question ID provided in your example (691)
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";
    
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
    
        const data = await response.json();
        // console.log("Character API response:", data);
    
        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || "strong or weak" }
        ]);
    
        // First hide all buttons to reset the display
        setHideInitialQuestions(true);
        
        // Parse the selection options
        if (data.selection) {
          // Need to clean up the selection string in case it contains newlines
          const cleanedSelection = data.selection.replace(/\n/g, '');
          
          // Parse the selection options 
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log("Character selections:", selections);
          
          // Set the buttons
          setQuestions(selections);
          
          // Important: Use a setTimeout to ensure state updates properly
          setTimeout(() => {
            setHideInitialQuestions(false); // Show these buttons
          }, 100);
        } else {
          // If no selections are returned, clear buttons
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);
        
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error("Error processing character options:", error);
        // Error handling...
        setLoading(false);
        setInput("");
        return;
      }
    }

    if (userQuery.toLowerCase().includes("money luck") || userQuery.includes("career luck")) {
      try {
        // Make the API call with the question ID
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";
    
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
    
        const data = await response.json();
        // console.log(`${userQuery} API response:`, data);
    
        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || "Let me analyze your luck..." }
        ]);
    
        // First hide all buttons to reset the display
        setHideInitialQuestions(true);
        
        // Parse the selection options
        if (data.selection) {
          // Need to clean up the selection string in case it contains newlines
          const cleanedSelection = data.selection.replace(/\n/g, '');
          
          // Parse the selection options 
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          // console.log(`${userQuery} selections:`, selections);
          
          // Set the buttons
          setQuestions(selections);
          
          // Important: Use a setTimeout to ensure state updates properly
          setTimeout(() => {
            setHideInitialQuestions(false); // Show these buttons
          }, 100);
        } else {
          // If no selections are returned, clear buttons
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);
        
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        // console.error(`Error processing ${userQuery}:`, error);
        // Error handling
        setLoading(false);
        setInput("");
        return;
      }
    }
      */

    // Only clear charts if it's a reset/restart
    if (userQuery === "-1") {
      try {
        // Preserve current identity data
        const currentGender = userGender;
        const currentNatal = lunarData?.A2;
        const currentChartStrength = chartStrengthData?.category;
        // console.log("Gender:", currentGender);
        // console.log("Natal:", currentNatal);
        // console.log("Chart Strength:", chartStrengthData?.category);
        await ensureCriticalData();

        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";

        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );

        const data = await response.json();
        
        // IMPORTANT: Get the actual user DOB from the user profile FIRST
        const userData = await fetchUserData();


        // // When you get DOB and time from CRM, combine them: (uncomment when testing)
        // const crmDate = "2001-01-08"; // from CRM
        // const crmTime = "00:00";      // from CRM

        // // Combine to ISO string in local time
        // const apiDate = `${crmDate}T${crmTime}:00.000+08:00`; // for Philippine Standard Time

        const actualBirthDate = userData?.DOB ? new Date(userData.DOB) : new Date(apiDate);
        
        const year = actualBirthDate.getFullYear();
        const month = (actualBirthDate.getMonth() + 1).toString().padStart(2, "0");
        const day = actualBirthDate.getDate().toString().padStart(2, "0");
        const hour = actualBirthDate.getHours();
        const minutes = actualBirthDate.getMinutes();

        // Format time as HH:MM
        const timeString = `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

        // console.log(`Using ACTUAL birth date for zodiac data: ${year}-${month}-${day} ${timeString}`);

        // Fetch lunar data using the CORRECT birth date and NEW API endpoint
        const lunarResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
        );

        const zodiacData = await lunarResponse.json();
        // console.log("Zodiac data from lunar API:", zodiacData);

        let lunarInsightsHtml = "";

        if (zodiacData && zodiacData.length > 0) {
          const zodiacInfo = zodiacData[0];
          const zodiacSign = zodiacInfo.ZODIAC;
          const zodiacChinese = zodiacInfo.ZODIAC_CN;
          
          // IMPORTANT: Use the FRESH natal element from the API response A2 field
          let natalElement = zodiacInfo.A2;

          // Make sure we display something even if natalElement is null
          const displayNatalElement = natalElement || "Unknown";
          // console.log("Final natal element to display:", displayNatalElement);
          
          // Important: Update the state with the NEW user's data
          setUserZodiac({
            sign: zodiacSign,
            chineseSign: zodiacChinese,
            natal: natalElement
          });
          
          // Update lunarData state with the new natal element
          setLunarData(prev => ({ 
            ...prev, 
            A2: natalElement 
          }));
          
          // Store in localStorage for persistence
          if (natalElement) {
            localStorage.setItem("userNatalElement", natalElement);
          }

          // Now create the lunar insights HTML with the FRESH data
          lunarInsightsHtml = `<div style="margin-bottom: 15px;"><div style="font-weight: bold; font-size: 1.1rem; margin-bottom: 5px;">Lunar Insights</div><div style="margin-bottom: 5px;">${displayNatalElement}</div><div>${zodiacSign} (${zodiacChinese})</div></div>`;
        }

        // Combine the API response with lunar insights
        const enhancedAnswer = `${lunarInsightsHtml}\n${data.answer}`;

        setMessages([
          { sender: "user", text: "Hello!" },
          { sender: "bot", text: enhancedAnswer },
        ]);

        // These lines ensure buttons don't appear initially:
        setHideInitialQuestions(true); // Changed from false to true
        setQuestions([]); // Empty the questions to ensure no buttons are shown

        // Only restore old data if the new fetch failed and we don't have fresh data
        if (!zodiacData || zodiacData.length === 0) {
          // console.log("Failed to fetch new user data, keeping previous data");
          if (!userGender || !lunarData?.A2 || !chartStrengthData?.category) {
            // console.log("Restoring identity data after failed -1 query");
            setUserGender(currentGender);
            setLunarData(prev => ({
              ...prev,
              A2: currentNatal
            }));
            setChartStrengthData(currentChartStrength);
          }
        }
        
        setHideInitialQuestions(false);
        setQuestions([]);
        setIsFinal(data.isfinal === 1);
      } catch (error) {
        // console.error("Error fetching initial response:", error);
        setMessages([
          { sender: "user", text: "Hello!" },
          {
            sender: "bot",
            text: "Sorry, but we didn't find what your looking for. Here, select any topic that might interest you",
          },
        ]);

        setQuestions([]);
        setHideInitialQuestions(false);
      }

      setLoading(false);
      setInput("");
      return;
    }

    // Check if this is a category button click
    const normalizedCategory = userQuery.trim().toLowerCase();

    if (categoryMap.hasOwnProperty(normalizedCategory)) {
      try {
        // Parse the date from apiDate state
        const birthDate = new Date(apiDate);
        const year = birthDate.getFullYear();
        const month = birthDate.getMonth() + 1; // JavaScript months are 0-based
        const day = birthDate.getDate();
        const hour = birthDate.getHours();
        const minutes = birthDate.getMinutes();

        // Format time as HH:MM
        const timeString = `${hour.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;

        // Use dynamic values instead of hardcoded ones
        const cGender = userGender?.toLowerCase() === "female" ? 1 : 0;
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/member/GetNatalDailyForecast?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}&cGender=${cGender}`
        );

        const data = await response.json();
        // console.log("Natal category API response:", data);

        // Check for Tables array and use only the first one
        if (data && data.Tables && data.Tables.length > 0) {
          // Use only the first table (index 0)
          const firstTable = data.Tables[0];

          if (firstTable && firstTable.length > 0) {
            const natalData = firstTable[0]; // First row of the first table

            const mapping = categoryMap[normalizedCategory];
            const value = natalData[mapping.apiKey] || 0;

            setHideCategoryButtons(true);

            setChartData({
              category: mapping.apiKey,
              label: mapping.displayName.split(" ")[0],
              value: value,
            });
            setChartTitle(mapping.displayName);
            setShowChart(true);
            setShowHelpButton(true);
            setCurrentCategory(normalizedCategory);

            setMessages((prev) => [
              ...prev,
              { sender: "user", text: userQuery },
              {
                sender: "bot",
                text: `Your ${mapping.displayName} is ${value}/100`,
              },
            ]);
          } else {
            throw new Error("No data in first table");
          }
        } else if (data && data.length > 0) {
          // Fallback to the old format if the Tables structure is not present
          const natalData = data[0];
          const mapping = categoryMap[normalizedCategory];
          const value = natalData[mapping.apiKey] || 0;

          // Rest of your existing code
          setHideCategoryButtons(true);
          setChartData({
            category: mapping.apiKey,
            label: mapping.displayName.split(" ")[0],
            value: value,
          });
          setChartTitle(mapping.displayName);
          setShowChart(true);
          setShowHelpButton(true);
          setCurrentCategory(normalizedCategory);

          setMessages((prev) => [
            ...prev,
            { sender: "user", text: userQuery },
            {
              sender: "bot",
              text: `Your ${mapping.displayName} is ${value}/100`,
            },
          ]);
        } else {
          throw new Error("No data returned from API");
        }
      } catch (error) {
        // console.error("Error fetching category data:", error);
        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            text: "Sorry, something went wrong retrieving your score.",
          },
        ]);
      }

      setLoading(false);
      setInput("");
      return;
    }

    // Reset chart display for regular messages
    // if (!userQuery.toLowerCase().includes("improve my")) {
    //   // Only reset chart if not asking for improvement
    //   setShowChart(true);
    //   setShowHelpButton(false);
    //   setHideCategoryButtons(false);
    //   setCurrentCategory(null);
    // } else {
    //   // Just hide the help button for improvement questions, but keep the chart
    //   setShowHelpButton(false);
    //   // Keep hideCategoryButtons true to show the Start Over button
    // }

    // try {
    //   let queryToSend = userQuery;
    
    //   // If we have zodiac info and this is a general query, add the context
    //   if (userZodiac.sign && !questionId && 
    //       !Object.keys(categoryMap).includes(userQuery.toLowerCase()) &&
    //       !userQuery.includes("zodiac") && 
    //       !userQuery.includes("natal")) {
    //     queryToSend = `${userQuery} (I am a ${userZodiac.sign} zodiac sign)`;
    //   }
    //   const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
    //   const idParam = questionId !== null ? `&questionid=${questionId}` : "";

    //   const response = await fetch(
    //     `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
    //   );

    //   const data = await response.json();
    //   // console.log(userQuery);
    //   // console.log(questionId);
    //   // console.log(data);

    //   const selections = data.selection
    //     ? data.selection.split(",").map((s, index) => {
    //         if (s.includes("|")) {
    //           const [id, text] = s.split("|");
    //           return { id, text };
    //         } else {
    //           return { id: index, text: s.trim() };
    //         }
    //       })
    //     : [];

    //   setMessages((prev) => [
    //     ...prev,
    //     { sender: "user", text: userQuery !== "-1" ? userQuery : "Hello!" },
    //     { sender: "bot", text: data.answer },
    //   ]);

    //   setIsFinal(data.isfinal === 1);
    //   setQuestions(selections);
    //   setHideInitialQuestions(true);
    // } catch (error) {
    //   // console.error("Error fetching response:", error);
    // }

    // if (userQuery.toLowerCase().includes("find out more about myself")) {
    //   try {
    //     // Make the API call
    //     const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
    //     const response = await fetch(
    //       `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}`
    //     );

    //     const data = await response.json();
    //     // console.log("Find out more response:", data);

    //     // Display the bot's response
    //     setMessages((prev) => [
    //       ...prev,
    //       { sender: "user", text: userQuery },
    //       { sender: "bot", text: data.answer || "What is your natal" }
    //     ]);

    //     // Fix: Hide all other buttons first
    //     setHideInitialQuestions(true);

    //     // Handle the selection options - key part for buttons
    //     if (data.selection) {
    //       // Need to clean up the selection string since it contains newlines
    //       const cleanedSelection = data.selection.replace(/\n/g, '');
          
    //       // Parse the selection options 
    //       const selections = cleanedSelection.split(',').map((s) => {
    //         if (s.includes("|")) {
    //           const [id, text] = s.split("|");
    //           return { id: id.trim(), text: text.trim() };
    //         } else {
    //           return { id: s, text: s.trim() };
    //         }
    //       });
          
    //       // console.log("Parsed selections:", selections);
          
    //       // Set the buttons
    //       setQuestions(selections);
          
    //       // Important: Use a setTimeout to ensure state updates properly
    //       setTimeout(() => {
    //         setHideInitialQuestions(false); // Now show these buttons
    //       }, 100);
          
    //       // Hide the "Sorry" message buttons by ensuring they don't match
    //       setMessages((prev) => prev.map(msg => {
    //         if (msg.sender === "bot" && 
    //             msg.text && 
    //             msg.text.includes("Sorry, but we didn't find what your looking for")) {
    //           // Replace the message text to prevent the Sorry buttons from showing
    //           return { ...msg, text: msg.text.replace("Sorry, but we didn't find what", "I couldn't find what") };
    //         }
    //         return msg;
    //       }));
    //     } else {
    //       setQuestions([]);
    //       setHideInitialQuestions(true);
    //     }
        
    //     setIsFinal(data.isfinal === 1);

    //     setLoading(false);
    //     setInput("");
    //     return;
    //   } catch (error) {
    //     // console.error("Error processing 'Find out more about myself':", error);
    //     // Error handling...
    //     setLoading(false);
    //     setInput("");
    //     return;
    //   }
    // }

    try {
      // If we reach this point, no specific keyword match was found
      // Add a special flag to indicate this is a fallback case
      const isUnrecognizedQuery = !questionId && normalizedQuery !== "-1";
      
      // For unrecognized queries, show sorry message and use -1 selection buttons
      if (isUnrecognizedQuery) {
        // console.log("Unknown query detected, fetching -1 options for fallback");
        
        // Add user message first
        // setMessages((prev) => [
        //   ...prev,
        //   { sender: "user", text: userQuery }
        // ]);

        // // Add sorry message
        // setMessages((prev) => [
        //   ...prev,
        //   { 
        //     sender: "bot", 
        //     text: "Sorry, but we didn't find what you're looking for. Here, select any topic that might interest you."
        //   }
        // ]);
        
        let fallbackSuggestions = [];
        try {
          const getKeyResp = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
          const getKeysData = await getKeyResp.json();

          const uniqueKeywords = new Set();
          getKeysData.forEach((mapping) => {
            const hasNoPeriod = mapping.QuestionText && !mapping.QuestionText.includes(".");
            const isGeneral = mapping.QuestionText && mapping.QuestionText.toLowerCase().includes("general");
            const hasNoPercentBracket = !mapping.PercentBracket || mapping.PercentBracket.trim() === "";

            if (mapping.KeywordText && hasNoPeriod && hasNoPercentBracket && isGeneral) {
              mapping.KeywordText.split(",").forEach((kw) => {
                const cleanedKeyword = kw.trim().toLowerCase();
                if (cleanedKeyword) {
                  uniqueKeywords.add(cleanedKeyword);
                }
              });
            }
          });

          fallbackSuggestions = Array.from(uniqueKeywords).slice(0, 50);
        } catch (keyErr) {
          // console.log("Error fetching getKey keywords for suggestions:", keyErr);
          fallbackSuggestions = [
            "wealth",
            "career",
            "health",
            "wisdom",
            "relationship",
          ];
        }

        setSuggestedKeywords(
          fallbackSuggestions.map((keyword) => ({
            id: keyword,
            text: keyword,
          }))
        );
        setSuggestionPage(0);

        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          {
            sender: "bot",
            text: "Keyword not recognized. Try one of the suggestions below.",
          },
        ]);

        setQuestions([]);
        setHideInitialQuestions(true);
        setLoading(false);
        setInput("");
        return; // Return early to prevent making another API call
      } else {
        // For recognized queries, make the normal API call
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        // console.log(`API response for query "${userQuery}":`, data);
        
        // Add user message and bot response
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer }
        ]);
        
        // Process selections from API response
        const selections = data.selection
          ? data.selection.split(",")
            .filter(s => s.trim())
            .map((s, index) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id, text: text.trim() };
              } else {
                return { id: index, text: s.trim() };
              }
            })
          : [];
        
        setQuestions(selections);
        setHideInitialQuestions(selections.length === 0);
        setIsFinal(data.isfinal === 1);
      }
    } catch (error) {
      // console.error("Error fetching response:", error);
      
      // On error, show sorry message and try to get -1 options
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { 
          sender: "bot", 
          text: "Sorry, but we didn't find what you're looking for. Here, select any topic that might interest you."
        }
      ]);
      
      // Try to fetch -1 options as fallback for error case too
      try {
        const errorFallbackResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${encodeURIComponent("-1")}`
        );
        
        const errorFallbackData = await errorFallbackResponse.json();
        
        if (errorFallbackData.selection) {
          const cleanedSelection = errorFallbackData.selection.replace(/\n/g, '');
          const errorFallbackOptions = cleanedSelection.split(',')
            .filter(s => s.trim())
            .map((s) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id: id.trim(), text: text.trim() };
              } else {
                return { id: s, text: s.trim() };
              }
            });
          
          setQuestions(errorFallbackOptions);
        } else {
          throw new Error("No selections in -1 response");
        }
      } catch (fallbackError) {
        // console.error("Error fetching -1 fallback:", fallbackError);
        
        // Final hardcoded fallback
        setQuestions([
          { id: "402", text: "This year zodiac reading" },
          { id: "629", text: "Find out more about myself male" },
          { id: "630", text: "Find out more about myself female" },
          { id: "643", text: "Natal zodiac pillar readings" },
          { id: "709", text: "Find out about my natal" }
        ]);
      }
      
      setHideInitialQuestions(false);
    }

    setLoading(false);
    setInput("");
  };

  // const fetchNatalData = async () => {
  //   setLoading(true);
  //     // Parse the date from apiDate state
  //     const birthDate = new Date(apiDate);
  //     const month = birthDate.getMonth() + 1; // JavaScript months are 0-based
  //     const day = birthDate.getDate();
  //     const hour = birthDate.getHours();
  //     const minutes = birthDate.getMinutes();
  //     const timeString = `${hour.toString().padStart(2, "0")}:${minutes
  //       .toString()
  //           {
  //             category: "CAREER",
  //             label: "Career",
  //             value: CAREER,
  //             title: "Career Score",
  //           },
  //           {
  //             category: "RS",
  //             label: "Relationship",
  //             value: RS,
  //             title: "Relationship Score",
  //           },
  //           {
  //             category: "HEALTH",
  //             label: "Health",
  //             value: HEALTH,
  //             title: "Health Score",
  //           },
  //           {
  //             category: "WISDOM",
  //             label: "Wisdom",
  //             value: WISDOM,
  //             title: "Wisdom Score",
  //           },
  //         ];

  //         // Display the natal reading introduction
  //         setMessages((prev) => [
  //           ...prev,
  //           {
  //             sender: "bot",
  //             text: "Here are your natal categories. Select one to see your score and get personalized insights:",
  //           },
  //         ]);

  //         // Create category buttons from API data
  //         const categoryButtons = Object.keys(categoryMap).map((category) => ({
  //           id: category,
  //           text: category.charAt(0).toUpperCase() + category.slice(1), // Capitalize first letter
  //         }));

  //         // Set questions to be our category buttons
  //         setQuestions(categoryButtons);

  //         // Update UI state to show topic buttons - making this more explicit
  //         setHideInitialQuestions(true);
  //         setHideCategoryButtons(false);
  //         setIsFinal(false);
  //         setCurrentCategory(null);
  //         setShowHelpButton(false);
  //       }
  //     } else if (data && data.length > 0) {
  //       // Fallback to the old format if the Tables structure is not present
  //       const natalData = data[0];
  //       // ... rest of the code remains the same
  //     } else {
  //       throw new Error("No valid data returned from API");
  //     }
  //   } catch (error) {
  //     // console.error("Error fetching natal data:", error);
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         sender: "bot",
  //         text: "Sorry, I couldn't retrieve your natal forecast at this time.",
  //       },
  //     ]);
  //   }
  //   setLoading(false);
  // };


  // Modify your return statement to better handle button display logic

  return (
    <div style={styles.chatbotContainer} className="chatbot-root">
      <button style={styles.chatbotButton} onClick={() => navigate("/chat")}>
        {/* {isOpen ? <IoIosCloseCircleOutline /> : <img src={chaticon} alt="chat" style={{ width: "26px", height: "26px", objectFit: "contain" }} />} */}
        <img src={chaticon} alt="chat" style={{ width: "32px", height: "32px", objectFit: "contain" }} />
      </button>
      <div style={{ ...styles.chatbot, display: isOpen ? "flex" : "none" }}>
        <div style={styles.messageContainer} className="chatbot-messages-scroll">
          {/* Messages display - unchanged */}
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                ...styles.messageBox,
                backgroundColor: msg.sender === "user" ? "#DFBD69" : "#2a2a2a",
                color: msg.sender === "user" ? "#1a1a1a" : "#f5f5f5",
              }}
            >
              {typeof msg.text === "string" ? (
                msg.text.includes("<div") ? (
                  <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                ) : (
                  msg.text
                )
              ) : (
                msg.text
              )}
            </div>
          ))}

          {loading && (
            <div style={{ ...styles.messageBox, backgroundColor: "#DFBD69", color: "black", textAlign: "left" }}>
              <span style={{ fontSize: "2rem"}}>
                {".".repeat(dotCount)}
              </span>
            </div>
          )}

          {/* {allCharts.length > 0 && (
            <div
              style={{
                ...styles.chartContainer,
                marginLeft: "0",
                marginBottom: "15px",
                textAlign: "center",
                margin: "15px auto",
                backgroundColor: "#e0e0e0",
              }}
            >
              <h3
                style={{
                  textAlign: "center",
                  margin: "0 0 15px 0",
                  fontSize: "1.1rem",
                  color: "#333",
                }}
              >
                Your Natal Scores
              </h3>
              {allCharts.map((chartData, index) => (
                <NatalChart
                  key={index}
                  data={{
                    category: chartData.category,
                    label: chartData.label,
                    value: chartData.value,
                  }}
                  title={chartData.title}
                />
              ))}
            </div>
          )} */}

          {/* Custom Chart */}
          {showChart && chartData && (
            <SimpleChart data={chartData} title={chartTitle} />
          )}

          {/* {loading && (
            <div style={{ ...styles.messageBox, backgroundColor: "#f1f1f1" }}>
              Loading...
            </div>
          )} */}
          {/* 4. Add this dummy div as the target for auto-scrolling */}
          <div ref={messagesEndRef} />
        </div>

        {/* Button section - Combined API buttons and category buttons */}
        {/* <div> */}
          {/* Only show API response buttons when not error AND they exist */}
          {/* {!isFinal && questions.length > 0 && !hideInitialQuestions && (
            <div style={{ padding: "10px", textAlign: "center" }}>
              {questions.map((question) => (
                <button
                  key={question.id}
                  onClick={() => {
                    if (question.text === "Who am I?" || question.text === "Who am I") {
                      handleWhoAmI();
                    } else {
                      fetchResponse(question.text, question.id);
                    }
                  }}
                  style={{
                    ...styles.questionButton,
                    margin: "3px",
                    display: "inline-block"
                  }}
                >
                  {question.text}
                </button>
              ))}
            </div>
          )} */}
          
          {/* Keep the "Sorry" message condition for backward compatibility */}
          {/* 
          {(messages.some(
              msg => msg.sender === "bot" && 
              msg.text && 
              msg.text.includes("Sorry, but we didn't find what your looking for")
          )) && 
          !isFinal && questions.length > 0 && !hideInitialQuestions &&
          (
            <div style={{ padding: "10px", textAlign: "center" }}>
              {questions.map((question) => (
                <button
                  key={question.id}
                  onClick={() => fetchResponse(question.text, question.id)}
                  style={{
                    ...styles.questionButton,
                    margin: "3px",
                    display: "inline-block"
                  }}
                >
                  {question.text}
                </button>
              ))}
            </div>
          )}
          */}
          

          {/* Help button remains unchanged */}
          {/* {showHelpButton && currentCategory && (
            <button
              style={styles.helpButton}
              onClick={() => {
                setShowChart(false);
                fetchResponse(`Tell me how to improve my ${currentCategory}`);
                setShowHelpButton(false);
                setShowRestartButton(true);
              }}
            >
              Let me help you
            </button>
          )} */}
        {/* </div> */}

        {suggestedKeywords.length > 0 && (() => {
          const totalPages = Math.ceil(suggestedKeywords.length / SUGGESTIONS_PER_PAGE);
          const currentSuggestions = suggestedKeywords.slice(
            suggestionPage * SUGGESTIONS_PER_PAGE,
            (suggestionPage + 1) * SUGGESTIONS_PER_PAGE
          );

          return (
            <div style={styles.suggestionSection}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <div style={{ ...styles.suggestionLabel, marginBottom: 0 }}>Try one of these</div>
                
                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button 
                      onClick={() => setSuggestionPage(Math.max(0, suggestionPage - 1))}
                      disabled={suggestionPage === 0}
                      style={{ 
                        background: 'transparent',
                        border: 'none',
                        color: suggestionPage === 0 ? '#555' : '#DFBD69', 
                        cursor: suggestionPage === 0 ? 'default' : 'pointer',
                        fontSize: '1rem',
                        padding: '0'
                      }}
                    >
                      â—€
                    </button>
                    <span style={{ color: '#DFBD69', fontSize: '0.75rem', opacity: 0.8 }}>
                      {suggestionPage + 1} / {totalPages}
                    </span>
                    <button 
                      onClick={() => setSuggestionPage(Math.min(totalPages - 1, suggestionPage + 1))}
                      disabled={suggestionPage === totalPages - 1}
                      style={{ 
                        background: 'transparent',
                        border: 'none',
                        color: suggestionPage === totalPages - 1 ? '#555' : '#DFBD69',
                        cursor: suggestionPage === totalPages - 1 ? 'default' : 'pointer',
                        fontSize: '1rem',
                        padding: '0'
                      }}
                    >
                      â–¶
                    </button>
                  </div>
                )}
              </div>

              <div style={styles.suggestionList}>
                {currentSuggestions.map((item) => (
                  <button
                    key={item.id}
                    style={styles.suggestionChip}
                    onClick={() => {
                      setInput(item.text);
                      fetchResponse(item.text);
                    }}
                  >
                    {item.text}
                  </button>
                ))}
              </div>
            </div>
          );
        })()}

        {/* Input container */}
        <div style={styles.inputContainer}>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message..."
            style={styles.input}
            onKeyPress={(e) => e.key === "Enter" && fetchResponse(input)}
          />
          <button onClick={() => fetchResponse(input)} style={styles.button}>
            Send
          </button>
        </div>
        <div style={styles.restartButtonContainer}>
          <button 
            onClick={handleRestart}
            style={styles.restartButtonBottom}
            title="Start a new conversation"
          >
            Restart
          </button>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;

